// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

/**
 * OTPAuthenticationMethodOut
 */
export const zOtpAuthenticationMethodOut = z.object({
    id: z.enum(['sms_otp', 'email_otp']),
    type: z.literal('otp'),
    display_name: z.string(),
    description: z.string()
});

/**
 * SSOAuthenticationMethodOut
 */
export const zSsoAuthenticationMethodOut = z.object({
    id: z.enum(['nextretail_sso', 'retailer_sso']),
    type: z.literal('sso'),
    provider: z.enum(['google', 'microsoft']),
    display_name: z.string(),
    description: z.string(),
    start_url: z.string()
});

/**
 * AuthenticationMethodErrorOut
 */
export const zAuthenticationMethodErrorOut = z.object({
    code: z.literal('bad_request'),
    detail: z.string()
});

/**
 * EmployeeContext
 */
export const zEmployeeContext = z.object({
    employee_id: z.uuid(),
    role: z.string(),
    retailer_id: z.optional(z.string()).default('')
});

/**
 * UserOut
 */
export const zUserOut = z.object({
    id: z.uuid(),
    email: z.string(),
    first_name: z.string(),
    last_name: z.string()
});

/**
 * AuthResponse
 */
export const zAuthResponse = z.object({
    user: zUserOut,
    employee: z.union([
        zEmployeeContext,
        z.null()
    ])
});

/**
 * AuthErrorOut
 */
export const zAuthErrorOut = z.object({
    detail: z.string()
});

/**
 * GoogleLoginIn
 */
export const zGoogleLoginIn = z.object({
    token: z.string()
});

/**
 * OTPRequestOut
 */
export const zOtpRequestOut = z.object({
    challenge_id: z.string(),
    detail: z.string()
});

/**
 * OTPErrorOut
 */
export const zOtpErrorOut = z.object({
    code: z.enum([
        'bad_request',
        'authentication_method_unavailable',
        'otp_request_rate_limited',
        'otp_verification_locked',
        'otp_verification_failed',
        'unsupported_media_type',
        'service_unavailable'
    ]),
    detail: z.string()
});

/**
 * OTPVerifyOut
 */
export const zOtpVerifyOut = z.object({
    access_token: z.string(),
    token_type: z.literal('Bearer'),
    expires_in: z.int()
});

/**
 * ApplicationSessionRefreshOut
 */
export const zApplicationSessionRefreshOut = z.object({
    access_token: z.string(),
    token_type: z.literal('Bearer'),
    expires_in: z.int()
});

/**
 * ApplicationSessionErrorOut
 */
export const zApplicationSessionErrorOut = z.object({
    code: z.string(),
    detail: z.string()
});

/**
 * SSOExchangeOut
 */
export const zSsoExchangeOut = z.object({
    access_token: z.string(),
    token_type: z.literal('Bearer'),
    expires_in: z.int()
});

/**
 * SSOExchangeErrorOut
 */
export const zSsoExchangeErrorOut = z.object({
    code: z.enum([
        'bad_request',
        'unauthorized',
        'unsupported_media_type',
        'service_unavailable',
        'internal_error'
    ]),
    detail: z.string()
});

/**
 * ResetCategoryRef
 *
 * Minimal category summary embedded in reset cycle responses.
 */
export const zResetCategoryRef = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    estimated_hours: z.union([
        z.number(),
        z.null()
    ]),
    priority_score: z.union([
        z.int(),
        z.null()
    ])
});

/**
 * CycleOut
 */
export const zCycleOut = z.object({
    id: z.uuid(),
    code: z.string(),
    cycle_name: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    week_number: z.union([
        z.int(),
        z.null()
    ]),
    status: z.string(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    categories: z.optional(z.array(zResetCategoryRef)).default([]),
    total_estimated_hours: z.union([
        z.number(),
        z.null()
    ])
});

/**
 * ProjectCycleSummary
 *
 * Planning cycle linked to the project's active execution cycle.
 */
export const zProjectCycleSummary = z.object({
    id: z.uuid(),
    cycle_name: z.string(),
    week_number: z.union([
        z.int(),
        z.null()
    ]),
    start_date: z.union([
        z.iso.date(),
        z.null()
    ]),
    end_date: z.union([
        z.iso.date(),
        z.null()
    ])
});

/**
 * ProjectProgressOut
 *
 * ``ProjectOut`` plus the per-project execution rollup that powers
 * the Mission Control Project Health table.
 *
 * ``list_projects`` attaches the counts; every other project endpoint
 * returns the plain :class:`ProjectOut` and omits them. A unit is a
 * typed work item; a project only ever has one work-item type.
 */
export const zProjectProgressOut = z.object({
    id: z.uuid(),
    name: z.string(),
    project_type: z.string(),
    store_group_id: z.union([
        z.uuid(),
        z.null()
    ]),
    description: z.string(),
    status: z.string(),
    generation_mode: z.string(),
    total_stores: z.int(),
    estimated_labor_hours: z.union([
        z.number(),
        z.null()
    ]),
    estimated_labor_cost: z.union([
        z.number(),
        z.null()
    ]),
    estimated_mileage_cost: z.union([
        z.number(),
        z.null()
    ]),
    estimated_total_cost: z.union([
        z.number(),
        z.null()
    ]),
    cost_estimate_metadata: z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ]),
    actual_total_hours: z.union([
        z.number(),
        z.null()
    ]),
    cycle: z.union([
        zProjectCycleSummary,
        z.null()
    ]),
    created_by_id: z.uuid(),
    approved_by_id: z.union([
        z.uuid(),
        z.null()
    ]),
    approved_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    agent_run_id: z.union([
        z.uuid(),
        z.null()
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    start_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    end_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    plan_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    category_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    cycle_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    estimated_hours: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_total_hours: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_cost: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    deadline: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    units_total: z.optional(z.int()).default(0),
    units_completed: z.optional(z.int()).default(0),
    stores_in_scope: z.optional(z.int()).default(0),
    nici_not_distributed: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    rollover_count: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    nici_stores_submitted: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    nici_not_on_shelf: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    compliance: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    actual_total_cost: z.optional(z.union([
        z.number(),
        z.null()
    ]))
});

/**
 * ProjectOut
 */
export const zProjectOut = z.object({
    id: z.uuid(),
    name: z.string(),
    project_type: z.string(),
    store_group_id: z.union([
        z.uuid(),
        z.null()
    ]),
    description: z.string(),
    status: z.string(),
    generation_mode: z.string(),
    total_stores: z.int(),
    estimated_labor_hours: z.union([
        z.number(),
        z.null()
    ]),
    estimated_labor_cost: z.union([
        z.number(),
        z.null()
    ]),
    estimated_mileage_cost: z.union([
        z.number(),
        z.null()
    ]),
    estimated_total_cost: z.union([
        z.number(),
        z.null()
    ]),
    cost_estimate_metadata: z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ]),
    actual_total_hours: z.union([
        z.number(),
        z.null()
    ]),
    cycle: z.union([
        zProjectCycleSummary,
        z.null()
    ]),
    created_by_id: z.uuid(),
    approved_by_id: z.union([
        z.uuid(),
        z.null()
    ]),
    approved_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    agent_run_id: z.union([
        z.uuid(),
        z.null()
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    start_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    end_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    plan_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    category_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    cycle_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    estimated_hours: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_total_hours: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_cost: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    deadline: z.optional(z.union([
        z.iso.date(),
        z.null()
    ]))
});

/**
 * ProjectIn
 */
export const zProjectIn = z.object({
    name: z.string(),
    project_type: z.string(),
    date_range: z.array(z.iso.date()),
    store_group_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    description: z.optional(z.string()).default(''),
    generation_mode: z.optional(z.string()).default('MANUAL'),
    total_stores: z.optional(z.int()).default(0),
    estimated_labor_hours: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_labor_cost: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_mileage_cost: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_total_cost: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    cost_estimate_metadata: z.optional(z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])),
    created_by_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * WorkItemType
 *
 * Discriminator for the type of work within a work order.
 */
export const zWorkItemType = z.enum(['RESET', 'NICI']);

/**
 * NiciResolutionOut
 */
export const zNiciResolutionOut = z.object({
    id: z.uuid(),
    work_item_id: z.uuid(),
    response_code: z.string(),
    price_tag_outcome: z.string(),
    completion_outcome: z.union([
        z.string(),
        z.null()
    ]),
    resolved_by_id: z.uuid(),
    visit_id: z.uuid(),
    resolved_at: z.iso.datetime(),
    device_timestamp: z.union([
        z.iso.datetime(),
        z.null()
    ])
});

/**
 * NiciSummaryOut
 */
export const zNiciSummaryOut = z.object({
    item_type: z.string(),
    status: z.string(),
    task_status: z.string(),
    submitted_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    aisle_numbers: z.union([
        z.string(),
        z.null()
    ]),
    bay_numbers: z.union([
        z.string(),
        z.null()
    ]),
    product_count: z.int(),
    product_categories: z.array(z.string()),
    completed_count: z.int(),
    remaining_count: z.int(),
    not_on_shelf_count: z.int(),
    rollover_count: z.int(),
    on_shelf_percent: z.int(),
    progress_label: z.string(),
    backroom_empty_proof_required: z.boolean(),
    item_completion_proof_photo_required: z.boolean(),
    not_scanned_confirmation_enabled: z.boolean()
});

/**
 * NiciTaskSource
 *
 * Composition of a NICI task — mixed is read-side only.
 */
export const zNiciTaskSource = z.enum([
    'REGULAR',
    'ROLLOVER',
    'MIXED'
]);

/**
 * WorkItemLocationOut
 *
 * One aisle and side where a store keeps a planogram.
 */
export const zWorkItemLocationOut = z.object({
    aisle: z.string(),
    side: z.string(),
    zone: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    bay_numbers: z.string()
});

/**
 * WorkItemProductOut
 */
export const zWorkItemProductOut = z.object({
    id: z.uuid(),
    name: z.string(),
    upc: z.string(),
    price_tag_code: z.string(),
    image_url: z.union([
        z.string(),
        z.null()
    ]),
    category: z.union([
        z.string(),
        z.null()
    ])
});

/**
 * WorkItemOut
 */
export const zWorkItemOut = z.object({
    nici_resolution: z.optional(z.union([
        zNiciResolutionOut,
        z.null()
    ])),
    id: z.uuid(),
    task_id: z.uuid(),
    nici_task_source: z.optional(z.union([
        zNiciTaskSource,
        z.null()
    ])),
    work_order_id: z.uuid(),
    project_id: z.uuid(),
    project_cycle_id: z.uuid(),
    store_id: z.uuid(),
    item_type: z.string(),
    category_id: z.union([
        z.uuid(),
        z.null()
    ]),
    category_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    priority_score: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    aisle_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    bay_numbers: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    zone: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    side: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    locations: z.optional(z.array(zWorkItemLocationOut)).default([]),
    pog_category_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    pog_category_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    planogram_id: z.union([
        z.uuid(),
        z.null()
    ]),
    product_id: z.union([
        z.uuid(),
        z.null()
    ]),
    nici_listing_id: z.union([
        z.uuid(),
        z.null()
    ]),
    target_date: z.union([
        z.iso.date(),
        z.null()
    ]),
    product_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    product: z.optional(z.union([
        zWorkItemProductOut,
        z.null()
    ])),
    aisle_number: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    proof_photo_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    barcode: z.string(),
    status: z.string(),
    task_status: z.string(),
    completed_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    completed_by_id: z.union([
        z.uuid(),
        z.null()
    ]),
    completion_source: z.string(),
    completion_method: z.string(),
    rollover_count: z.int(),
    rollover_reason: z.string(),
    item_status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    distribution_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    notes: z.string(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * PaginatedWorkItemResponse
 */
export const zPaginatedWorkItemResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zWorkItemOut),
    summary: z.optional(z.union([
        zNiciSummaryOut,
        z.null()
    ]))
});

/**
 * WorkItemPatch
 */
export const zWorkItemPatch = z.object({
    status: z.literal('PENDING')
});

/**
 * BackroomNewItemProgressOut
 */
export const zBackroomNewItemProgressOut = z.object({
    found: z.int(),
    total: z.int()
});

/**
 * BackroomNewItemRequirementOut
 */
export const zBackroomNewItemRequirementOut = z.object({
    product_id: z.uuid(),
    product_image_url: z.union([
        z.string(),
        z.null()
    ]),
    product_name: z.string(),
    barcode: z.string(),
    code: z.string(),
    planogram_category_id: z.union([
        z.uuid(),
        z.null()
    ]),
    planogram_category_name: z.string(),
    scan_status: z.string()
});

/**
 * BackroomNewItemRequirementsOut
 */
export const zBackroomNewItemRequirementsOut = z.object({
    enabled: z.boolean(),
    should_collect: z.boolean(),
    skip_reason: z.union([
        z.string(),
        z.null()
    ]),
    work_item_id: z.uuid(),
    work_order_id: z.uuid(),
    planogram_id: z.union([
        z.uuid(),
        z.null()
    ]),
    progress: zBackroomNewItemProgressOut,
    items: z.array(zBackroomNewItemRequirementOut)
});

/**
 * BackroomNewItemCollectionItemOut
 */
export const zBackroomNewItemCollectionItemOut = z.object({
    id: z.uuid(),
    product_id: z.uuid(),
    product_image_url: z.union([
        z.string(),
        z.null()
    ]),
    product_name: z.string(),
    barcode: z.string(),
    code: z.string(),
    planogram_category_id: z.union([
        z.uuid(),
        z.null()
    ]),
    planogram_category_name: z.string(),
    scan_status: z.string(),
    scanned_barcode: z.string(),
    scanned_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    scanner_source: z.string(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * BackroomNewItemCollectionOut
 */
export const zBackroomNewItemCollectionOut = z.object({
    id: z.uuid(),
    visit_id: z.uuid(),
    work_order_id: z.uuid(),
    work_item_id: z.uuid(),
    store_id: z.uuid(),
    employee_id: z.uuid(),
    planogram_id: z.union([
        z.uuid(),
        z.null()
    ]),
    photo_id: z.union([
        z.uuid(),
        z.null()
    ]),
    status: z.string(),
    started_at: z.iso.datetime(),
    completed_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    progress: zBackroomNewItemProgressOut,
    items: z.array(zBackroomNewItemCollectionItemOut),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * BackroomNewItemCollectionActionOut
 */
export const zBackroomNewItemCollectionActionOut = z.object({
    outcome: z.string(),
    collection: zBackroomNewItemCollectionOut
});

/**
 * BackroomNewItemCollectionActionIn
 */
export const zBackroomNewItemCollectionActionIn = z.object({
    visit_id: z.uuid(),
    action: z.string(),
    field_photo_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    barcode: z.optional(z.string()).default(''),
    scanner_source: z.optional(z.string()).default('CAMERA')
});

/**
 * ExceptionEventMetadata
 */
export const zExceptionEventMetadata = z.object({
    latitude: z.optional(z.union([
        z.number().gte(-90).lte(90),
        z.null()
    ])),
    longitude: z.optional(z.union([
        z.number().gte(-180).lte(180),
        z.null()
    ])),
    distance_from_store_meters: z.optional(z.union([
        z.number().gte(0),
        z.null()
    ])),
    gps_accuracy_meters: z.optional(z.union([
        z.number().gte(0),
        z.null()
    ])),
    geofence_radius_meters: z.optional(z.union([
        z.number().gte(0),
        z.null()
    ]))
});

/**
 * ExceptionEventOut
 */
export const zExceptionEventOut = z.object({
    id: z.uuid(),
    visit_id: z.uuid(),
    work_order_id: z.uuid(),
    work_item_id: z.union([
        z.uuid(),
        z.null()
    ]),
    store_id: z.uuid(),
    employee_id: z.uuid(),
    event_time_utc: z.iso.datetime(),
    exception_type_name: z.string(),
    exception_type_id: z.string(),
    severity: z.string(),
    reason_code: z.string(),
    bay_number: z.union([
        z.int(),
        z.null()
    ]),
    description: z.string(),
    metadata: zExceptionEventMetadata,
    related_photo_id: z.union([
        z.uuid(),
        z.null()
    ]),
    resolution_status: z.string(),
    resolved_by_id: z.union([
        z.uuid(),
        z.null()
    ]),
    resolved_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * ExceptionEventIn
 */
export const zExceptionEventIn = z.object({
    visit_id: z.uuid(),
    work_item_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    event_time_utc: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    exception_type_id: z.uuid(),
    severity: z.string(),
    reason_code: z.optional(z.string()).default(''),
    bay_number: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    is_new_bay: z.optional(z.boolean()).default(false),
    description: z.optional(z.string()).default(''),
    metadata: z.optional(zExceptionEventMetadata),
    related_photo_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * ExceptionEventTypeGroup
 *
 * Workflow group for an admin-managed exception event type.
 */
export const zExceptionEventTypeGroup = z.enum([
    'BEFORE_BAY_CAPTURE',
    'AFTER_BAY_CAPTURE',
    'LOCATION_VALIDATION',
    'OTHER'
]);

/**
 * ExceptionEventTypeOut
 */
export const zExceptionEventTypeOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    groups: z.union([
        z.array(z.string()),
        z.null()
    ]),
    description: z.string(),
    is_active: z.boolean(),
    sort_order: z.int(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * PaginatedExceptionEventTypeResponse
 */
export const zPaginatedExceptionEventTypeResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zExceptionEventTypeOut)
});

/**
 * PhotoPhase
 *
 * Timing phase when a photo was captured.
 */
export const zPhotoPhase = z.enum([
    'BEFORE',
    'AFTER',
    'PROOF'
]);

/**
 * PhotoType
 *
 * Subject / purpose of a compliance photo.
 */
export const zPhotoType = z.enum([
    'SHELF_WIDE',
    'SECTION_DETAIL',
    'CLOSE_UP',
    'PRICE_TAG',
    'ENDCAP',
    'BACKROOM',
    'OTHER'
]);

/**
 * FieldPhotoFileOut
 */
export const zFieldPhotoFileOut = z.object({
    id: z.uuid(),
    folder: z.string(),
    original_name: z.string(),
    mime_type: z.string(),
    file_size: z.int(),
    state: z.string(),
    url: z.optional(z.string()).default(''),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * FieldPhotoOut
 */
export const zFieldPhotoOut = z.object({
    id: z.uuid(),
    visit_id: z.uuid(),
    work_order_id: z.uuid(),
    work_item_id: z.union([
        z.uuid(),
        z.null()
    ]),
    store_id: z.uuid(),
    employee_id: z.uuid(),
    captured_at_utc: z.iso.datetime(),
    captured_at: z.iso.datetime(),
    photo_id: z.uuid(),
    photo: zFieldPhotoFileOut,
    photo_type: z.string(),
    photo_phase: z.string(),
    bay_number: z.union([
        z.int(),
        z.null()
    ]),
    category_id: z.union([
        z.uuid(),
        z.null()
    ]),
    planogram_id: z.union([
        z.uuid(),
        z.null()
    ]),
    barcode: z.string(),
    device_model: z.string(),
    edge_validation_passed: z.union([
        z.boolean(),
        z.null()
    ]),
    edge_validation_errors: z.array(z.unknown()),
    cv_quality_scores: z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ]),
    sync_status: z.string(),
    notes: z.string(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * PaginatedFieldPhotoResponse
 */
export const zPaginatedFieldPhotoResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zFieldPhotoOut)
});

/**
 * ProjectPatch
 */
export const zProjectPatch = z.object({
    name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    project_type: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    store_group_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    description: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    generation_mode: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    total_stores: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    estimated_labor_hours: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_labor_cost: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_mileage_cost: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_total_cost: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    cost_estimate_metadata: z.optional(z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])),
    actual_total_hours: z.optional(z.union([
        z.number(),
        z.null()
    ]))
});

/**
 * TransitionIn
 */
export const zTransitionIn = z.object({
    status: z.string()
});

/**
 * BlockerOut
 */
export const zBlockerOut = z.object({
    blocker_type: z.string(),
    message: z.string()
});

/**
 * HolidayOut
 */
export const zHolidayOut = z.object({
    id: z.uuid(),
    date: z.iso.date(),
    name: z.string()
});

/**
 * CycleSummaryOut
 */
export const zCycleSummaryOut = z.object({
    cycle_id: z.uuid(),
    cycle_number: z.int(),
    name: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    category_count: z.int(),
    eligible_store_count: z.int(),
    nici_item_count: z.int(),
    has_work: z.boolean(),
    holidays: z.array(zHolidayOut)
});

/**
 * ScopeExceptionOut
 *
 * Mapping exception for user review in Step 2.
 *
 * Maps from the scope engine's ``MappingException`` dataclass.
 * Shown in the AI Analysis screen so the user can review missing
 * or incomplete store-category mappings.
 */
export const zScopeExceptionOut = z.object({
    exception_type: z.string(),
    severity: z.string(),
    message: z.string(),
    store_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    store_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    store_code: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    category_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    category_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    cycle_number: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    missing_role: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * WizardInitOut
 *
 * Response body of ``POST /wizard/init``.
 *
 * Inherits the full scope-slot payload from
 * :class:`ScopeSlotSchema` and adds the newly created draft
 * project's id. The wire format stays identical to the
 * shape — all totals, cycles, blockers, warnings and
 * ``can_proceed`` are still present (now inherited).
 */
export const zWizardInitOut = z.object({
    inputs_hash: z.string(),
    total_cycles: z.int(),
    cycles_with_work: z.int(),
    cycles_skipped: z.int(),
    total_categories: z.int(),
    total_eligible_stores: z.int(),
    total_nici_items: z.int(),
    category_ids: z.optional(z.array(z.uuid())),
    available_category_ids: z.optional(z.array(z.uuid())),
    cycles: z.array(zCycleSummaryOut),
    blockers: z.array(zBlockerOut),
    can_proceed: z.boolean(),
    warnings: z.array(z.string()),
    exceptions: z.optional(z.array(zScopeExceptionOut)),
    planning_input_version: z.optional(z.string()).default(''),
    rollover_included: z.optional(z.boolean()).default(false),
    project_id: z.uuid()
});

/**
 * SchedulingMode
 *
 * Who covers a project's store visits.
 */
export const zSchedulingMode = z.enum(['SOLO', 'GROUP']);

/**
 * WizardInitIn
 */
export const zWizardInitIn = z.object({
    project_type: z.string(),
    name: z.string().min(1).max(255),
    date_range: z.tuple([z.iso.date(), z.iso.date()]),
    store_group_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    description: z.optional(z.string()).default(''),
    scheduling_mode: z.optional(zSchedulingMode).default('SOLO')
});

/**
 * AssignmentOverride
 *
 * Reserved placeholder.
 */
export const zAssignmentOverride = z.record(z.string(), z.never());

/**
 * BuddyPairInfo
 *
 * Buddy pair summary for UI display.
 */
export const zBuddyPairInfo = z.object({
    employee_a_id: z.uuid(),
    employee_a_name: z.string(),
    employee_b_id: z.uuid(),
    employee_b_name: z.string(),
    pair_type: z.string(),
    shared_stores: z.int()
});

/**
 * CategoryMoveOverride
 *
 * One category moved between cycles during schedule review.
 *
 * Populated by move-category endpoint.
 * Read and applied by the schedule generator.
 */
export const zCategoryMoveOverride = z.object({
    category_id: z.uuid(),
    from_cycle: z.int().gt(0),
    to_cycle: z.int().gt(0)
});

/**
 * CostWarning
 *
 * Unified warning for the Step 5 cost review screen.
 */
export const zCostWarning = z.object({
    warning_type: z.string(),
    severity: z.string(),
    message: z.string(),
    employee_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    employee_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    store_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    store_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    cycle_number: z.optional(z.union([
        z.int(),
        z.null()
    ]))
});

/**
 * CycleAssignment
 *
 * One assignment: employee → store within a cycle.
 */
export const zCycleAssignment = z.object({
    store_id: z.uuid(),
    store_name: z.string(),
    code: z.string(),
    employee_id: z.uuid(),
    employee_name: z.string(),
    assignment_type: z.enum([
        'HOME_BASE',
        'TEAM_ROTATION',
        'DYNAMIC',
        'GROUP'
    ]),
    cycle_number: z.int(),
    scheduled_date: z.iso.date(),
    estimated_hours: z.number(),
    group_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    distance_miles: z.optional(z.union([
        z.number(),
        z.null()
    ]))
});

/**
 * CycleAssignmentSummary
 *
 * Per-cycle assignment summary for Step 4 UI.
 */
export const zCycleAssignmentSummary = z.object({
    cycle_number: z.int(),
    cycle_name: z.string(),
    total_assigned: z.int(),
    home_base_count: z.int(),
    team_rotation_count: z.int(),
    group_count: z.optional(z.int()).default(0),
    dynamic_count: z.int(),
    unassigned_count: z.int(),
    total_employees: z.int(),
    total_hours: z.number(),
    is_overloaded: z.boolean(),
    has_distance_warnings: z.boolean()
});

/**
 * CycleCostSummary
 *
 * Merged labor + mileage breakdown for one cycle.
 */
export const zCycleCostSummary = z.object({
    cycle_number: z.int(),
    labor_hours: z.number(),
    labor_cost: z.number(),
    labor_assignment_count: z.int(),
    mileage_miles: z.number(),
    mileage_cost: z.number(),
    mileage_assignment_count: z.int(),
    mileage_skipped_count: z.int(),
    total_cost: z.number()
});

/**
 * CycleDateOverride
 *
 * Per-cycle date range override for defer-with-dates.
 *
 * Populated by POST /schedule/apply. Read by the schedule
 * generator to replace the default effective range of a cycle.
 */
export const zCycleDateOverride = z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date()
});

/**
 * DistanceWarning
 *
 * Travel radius exceeded for an assignment.
 */
export const zDistanceWarning = z.object({
    employee_id: z.uuid(),
    employee_name: z.string(),
    store_id: z.uuid(),
    store_name: z.string(),
    cycle_number: z.int(),
    distance_miles: z.number(),
    travel_radius_miles: z.number()
});

/**
 * EmployeeCostSummary
 *
 * Merged labor + mileage breakdown for one employee.
 */
export const zEmployeeCostSummary = z.object({
    employee_id: z.uuid(),
    employee_name: z.string(),
    role_title: z.string(),
    hourly_rate: z.number(),
    rate_source: z.string(),
    labor_hours: z.number(),
    labor_cost: z.number(),
    mileage_miles: z.number(),
    mileage_cost: z.number(),
    total_cost: z.number(),
    store_count: z.int(),
    cycle_count: z.int()
});

/**
 * CostSlotSchema
 *
 * Cost slot persisted in wizard_state['cost'].
 *
 * Produced by the cost estimator.
 * Consumed by T-016 (project finalization),
 * resume endpoint, and frontend Step 5 UI.
 */
export const zCostSlotSchema = z.object({
    inputs_hash: z.string(),
    total_labor_hours: z.number(),
    total_labor_cost: z.number(),
    unassigned_labor_hours: z.optional(z.number()).default(0),
    unassigned_labor_cost: z.optional(z.number()).default(0),
    total_miles: z.number(),
    total_mileage_cost: z.number(),
    total_estimated_cost: z.number(),
    stores_assigned: z.int(),
    stores_total: z.int(),
    store_coverage_pct: z.int(),
    field_team_count: z.int(),
    per_cycle: z.array(zCycleCostSummary),
    per_employee: z.array(zEmployeeCostSummary),
    warnings: z.array(zCostWarning),
    labor_rate_snapshot: z.optional(z.record(z.string(), z.unknown())),
    mileage_rate_snapshot: z.optional(z.record(z.string(), z.unknown()))
});

/**
 * EmployeeCycleLoad
 *
 * Per-employee workload in one cycle.
 */
export const zEmployeeCycleLoad = z.object({
    employee_id: z.uuid(),
    employee_name: z.string(),
    role_title: z.string(),
    cycle_number: z.int(),
    assigned_hours: z.number(),
    max_weekly_hours: z.number(),
    store_count: z.int(),
    is_overloaded: z.boolean()
});

/**
 * OverridesSchema
 *
 * User-authored choices and edits saved with a draft project.
 *
 * Full-replacement semantics: PATCH /save-draft replaces the
 * entire overrides block on each call. The server never merges
 * fields — the client sends the full desired state.
 *
 * ``None`` for ``category_ids`` / ``store_ids`` means "no
 * override" (use the default set derived from project type and
 * store group). An empty list ``[]`` means "explicit empty
 * selection" (exclude everything).
 */
export const zOverridesSchema = z.object({
    category_ids: z.optional(z.union([
        z.array(z.uuid()).max(10000),
        z.null()
    ])),
    store_ids: z.optional(z.union([
        z.array(z.uuid()).max(10000),
        z.null()
    ])),
    schedule_on_holidays: z.optional(z.record(z.string(), z.boolean())),
    notes: z.optional(z.string().max(10000)).default(''),
    cycle_actions: z.optional(z.record(z.string(), z.enum(['skip', 'defer']))),
    category_moves: z.optional(z.array(zCategoryMoveOverride).max(1000)),
    cycle_date_overrides: z.optional(z.record(z.string(), zCycleDateOverride)),
    assignment_overrides: z.optional(z.array(zAssignmentOverride).max(1000)),
    nici_rollover_exclusions: z.optional(z.array(z.uuid()).max(1000))
});

/**
 * ScheduleWarning
 *
 * A non-fatal scheduling warning for the Step 3 schedule review.
 *
 * Per (cycle, store). Non-blocking — the project stays buildable; the
 * planner resolves overflow manually (extend cycle / edit shifts /
 * overrides).
 */
export const zScheduleWarning = z.object({
    warning_type: z.enum([
        'SCHEDULE_OVERFLOW',
        'NO_SHIFT_DAYS',
        'NO_SHIFTS'
    ]),
    cycle_number: z.int(),
    store_id: z.uuid(),
    store_name: z.string(),
    code: z.string(),
    message: z.string()
});

/**
 * ScheduledStoreOut
 *
 * One store assigned to a working day in the schedule.
 */
export const zScheduledStoreOut = z.object({
    store_id: z.uuid(),
    store_name: z.string(),
    code: z.string(),
    estimated_hours: z.number()
});

/**
 * ScheduleDayOut
 *
 * One working day within a cycle's schedule.
 */
export const zScheduleDayOut = z.object({
    date: z.iso.date(),
    day_name: z.enum([
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI',
        'SAT',
        'SUN'
    ]),
    store_count: z.int(),
    total_hours: z.number(),
    stores: z.array(zScheduledStoreOut)
});

/**
 * CycleScheduleOut
 *
 * Full schedule for one project cycle.
 */
export const zCycleScheduleOut = z.object({
    cycle_number: z.int(),
    name: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    status: z.enum([
        'SCHEDULED',
        'SKIPPED',
        'NO_WORK'
    ]),
    work_day_count: z.int(),
    holidays_skipped: z.array(zHolidayOut),
    holidays_included: z.array(zHolidayOut),
    total_stores: z.int(),
    total_categories: z.int(),
    total_hours: z.number(),
    work_hours: z.optional(z.number()).default(0),
    days: z.array(zScheduleDayOut)
});

/**
 * ScopeSlotSchema
 *
 * Cached scope analysis result for a draft project.
 *
 * Produced by the scope aggregator and stored inside
 * ``wizard_state`` so the UI can render Step 2 without
 * recomputing. ``inputs_hash`` is a stable fingerprint of the
 * inputs that produced this slot; a mismatch against the
 * current project basics + overrides indicates the cached
 * scope is stale and must be recomputed.
 */
export const zScopeSlotSchema = z.object({
    inputs_hash: z.string(),
    total_cycles: z.int(),
    cycles_with_work: z.int(),
    cycles_skipped: z.int(),
    total_categories: z.int(),
    total_eligible_stores: z.int(),
    total_nici_items: z.int(),
    category_ids: z.optional(z.array(z.uuid())),
    available_category_ids: z.optional(z.array(z.uuid())),
    cycles: z.array(zCycleSummaryOut),
    blockers: z.array(zBlockerOut),
    can_proceed: z.boolean(),
    warnings: z.array(z.string()),
    exceptions: z.optional(z.array(zScopeExceptionOut)),
    planning_input_version: z.optional(z.string()).default(''),
    rollover_included: z.optional(z.boolean()).default(false)
});

/**
 * StaffingWarning
 *
 * Nonblocking staffing gap on a dated appointment.
 */
export const zStaffingWarning = z.object({
    store_id: z.uuid(),
    cycle_number: z.int(),
    scheduled_date: z.iso.date(),
    group_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    employee_ids: z.optional(z.array(z.uuid())),
    reason: z.string(),
    message: z.string()
});

/**
 * StaleFlags
 *
 * Per-step staleness markers for wizard resume.
 */
export const zStaleFlags = z.object({
    scope: z.optional(z.boolean()).default(false),
    schedule: z.optional(z.boolean()).default(false),
    assignments: z.optional(z.boolean()).default(false),
    cost: z.optional(z.boolean()).default(false)
});

/**
 * UnassignedStore
 *
 * Store that could not be assigned to any employee.
 */
export const zUnassignedStore = z.object({
    store_id: z.uuid(),
    store_name: z.string(),
    code: z.string(),
    cycle_number: z.int(),
    scheduled_date: z.iso.date(),
    estimated_hours: z.number(),
    reason: z.enum([
        'NO_HOME_BASE',
        'AMBIGUOUS_HOME_BASE',
        'NO_ACTIVE_GROUP',
        'INVALID_GROUP',
        'EMPLOYEE_UNAVAILABLE',
        'NO_MAPPING',
        'ALL_UNAVAILABLE',
        'ALL_AT_CAPACITY',
        'ALL_AT_DAILY_CAPACITY',
        'NO_SHIFT_COVERAGE',
        'NO_ELIGIBLE_EMPLOYEE'
    ])
});

/**
 * AssignmentSlotSchema
 *
 * Assignment slot persisted in wizard_state['assignments'].
 *
 * Produced by assignment engine.
 * Consumed by gap detection, cost,
 * cost summary, project builder.
 */
export const zAssignmentSlotSchema = z.object({
    inputs_hash: z.string(),
    staffing_warnings: z.optional(z.array(zStaffingWarning)),
    total_assignments: z.int(),
    home_base_count: z.int(),
    team_rotation_count: z.int(),
    group_count: z.optional(z.int()).default(0),
    dynamic_count: z.int(),
    unassigned_count: z.int(),
    total_employees: z.int(),
    assignments: z.array(zCycleAssignment),
    unassigned: z.array(zUnassignedStore),
    employee_cycle_loads: z.array(zEmployeeCycleLoad),
    distance_warnings: z.array(zDistanceWarning),
    buddy_pairs: z.array(zBuddyPairInfo),
    cycle_summaries: z.optional(z.array(zCycleAssignmentSummary))
});

/**
 * UnscheduledStore
 *
 * Store work in a planned cycle that got no visit date.
 */
export const zUnscheduledStore = z.object({
    cycle_number: z.int(),
    store_id: z.uuid(),
    store_name: z.string(),
    code: z.string(),
    estimated_hours: z.number(),
    reason: z.enum(['NO_WORKING_DAYS', 'INSUFFICIENT_WORKING_DAYS']),
    required_visits: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    available_days: z.optional(z.union([
        z.int(),
        z.null()
    ]))
});

/**
 * ScheduleSlotSchema
 *
 * Schedule slot persisted in wizard_state['schedule'].
 *
 * Produced by the schedule generator.
 * Consumed by cycle manipulation, team
 * assignment, and cost calculation.
 */
export const zScheduleSlotSchema = z.object({
    inputs_hash: z.string(),
    total_cycles: z.int(),
    cycles_scheduled: z.int(),
    cycles_skipped: z.int(),
    total_work_days: z.int(),
    total_stores: z.int(),
    total_hours: z.number(),
    baseline_version: z.optional(z.int()).default(0),
    total_visits: z.optional(z.int()).default(0),
    total_work_hours: z.optional(z.number()).default(0),
    cycles: z.array(zCycleScheduleOut),
    unscheduled: z.optional(z.array(zUnscheduledStore)),
    warnings: z.optional(z.array(zScheduleWarning)),
    exceptions: z.optional(z.array(zScopeExceptionOut))
});

/**
 * WizardStateOut
 *
 * The full ``wizard_state`` JSONB payload as sent to the UI.
 */
export const zWizardStateOut = z.object({
    overrides: zOverridesSchema,
    scope: z.optional(z.union([
        zScopeSlotSchema,
        z.null()
    ])),
    schedule: z.optional(z.union([
        zScheduleSlotSchema,
        z.null()
    ])),
    assignments: z.optional(z.union([
        zAssignmentSlotSchema,
        z.null()
    ])),
    cost: z.optional(z.union([
        zCostSlotSchema,
        z.null()
    ])),
    stale: z.optional(zStaleFlags)
});

/**
 * SaveDraftOut
 *
 * Response body of ``PATCH /wizard/save-draft``.
 */
export const zSaveDraftOut = z.object({
    project_id: z.uuid(),
    wizard_step: z.int(),
    wizard_state: zWizardStateOut,
    updated_at: z.string()
});

/**
 * ProjectType
 *
 * High-level category of a merchandising project.
 */
export const zProjectType = z.enum([
    'RESET',
    'NICI',
    'REMODEL'
]);

/**
 * ProjectBasicsIn
 *
 * Project basics block accepted by ``PATCH /save-draft``.
 */
export const zProjectBasicsIn = z.object({
    name: z.string().min(1).max(255),
    project_type: zProjectType,
    scheduling_mode: z.optional(zSchedulingMode).default('SOLO'),
    description: z.optional(z.string().max(10000)).default(''),
    date_range: z.tuple([z.iso.date(), z.iso.date()]),
    store_group_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * WizardStep
 *
 * Wizard step reached during project creation.
 */
export const zWizardStep = z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5)
]);

/**
 * SaveDraftIn
 *
 * Body of PATCH /save-draft. Unified project-basics +
 * overrides editor. Full-replacement semantics for both
 * sub-blocks.
 */
export const zSaveDraftIn = z.object({
    project: zProjectBasicsIn,
    overrides: zOverridesSchema,
    step: z.optional(z.union([
        zWizardStep,
        z.null()
    ]))
});

/**
 * ProjectBasicsOut
 *
 * Project basics block returned by ``GET /wizard/resume``.
 */
export const zProjectBasicsOut = z.object({
    id: z.uuid(),
    name: z.string(),
    project_type: z.string(),
    scheduling_mode: zSchedulingMode,
    description: z.string(),
    start_date: z.union([
        z.iso.date(),
        z.null()
    ]),
    end_date: z.union([
        z.iso.date(),
        z.null()
    ]),
    store_group_id: z.union([
        z.uuid(),
        z.null()
    ]),
    status: z.string()
});

/**
 * ResumeOut
 *
 * Response body of ``GET /wizard/resume``.
 */
export const zResumeOut = z.object({
    project: zProjectBasicsOut,
    wizard_step: z.int(),
    saved_step: z.union([
        z.int(),
        z.null()
    ]),
    wizard_state: zWizardStateOut,
    updated_at: z.string()
});

/**
 * CategoryOut
 *
 * Response body for a single category.
 *
 * Attributes:
 * id: Unique UUID of the category.
 * code: External identifier from the retailer's
 * source system.
 * name: Human-readable category name.
 * level: Hierarchy depth (1 = root), auto-calculated by
 * the database.
 * parent_id: UUID of the parent category, or ``None``
 * for root nodes.
 * priority_score: AI-assigned priority for ordering.
 * created_at: Timestamp when the category was created.
 * updated_at: Timestamp of the last update.
 */
export const zCategoryOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    level: z.union([
        z.int(),
        z.null()
    ]),
    parent_id: z.union([
        z.uuid(),
        z.null()
    ]),
    parent_name: z.union([
        z.string(),
        z.null()
    ]),
    priority_score: z.int(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * ProjectTypeOption
 */
export const zProjectTypeOption = z.object({
    value: z.string(),
    label: z.string()
});

/**
 * WizardOptionsOut
 */
export const zWizardOptionsOut = z.object({
    categories: z.array(zCategoryOut),
    cycles: z.array(zCycleOut),
    project_types: z.array(zProjectTypeOption),
    backend_transcription: z.boolean()
});

/**
 * WizardProjectTypesOut
 *
 * Lightweight subset of the wizard options.
 *
 * Returns only the task-type choices and the transcription flag, so
 * the create-project form can render its Task Type cards without
 * loading the heavy categories and cycles lists.
 */
export const zWizardProjectTypesOut = z.object({
    project_types: z.array(zProjectTypeOption),
    backend_transcription: z.boolean()
});

/**
 * ParsedStoreScope
 *
 * Store scope extracted from a natural-language project description.
 *
 * Defaults to ``mode="all"`` when the description does not mention a
 * specific group or store list. ``store_group_id`` / ``manual_store_ids``
 * are best-effort — resolution to real IDs happens downstream.
 */
export const zParsedStoreScope = z.object({
    mode: z.optional(z.enum([
        'all',
        'store_group',
        'manual'
    ])),
    store_group_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    store_group_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    manual_store_ids: z.optional(z.array(z.uuid()))
});

/**
 * ParseDescriptionOut
 */
export const zParseDescriptionOut = z.object({
    project_type: z.union([
        z.string(),
        z.null()
    ]),
    category_name: z.union([
        z.string(),
        z.null()
    ]),
    category_id: z.union([
        z.uuid(),
        z.null()
    ]),
    cycle_week: z.union([
        z.int(),
        z.null()
    ]),
    plan_id: z.union([
        z.uuid(),
        z.null()
    ]),
    project_name: z.union([
        z.string(),
        z.null()
    ]),
    confidence: z.number(),
    date_range: z.optional(z.union([
        z.array(z.iso.date()),
        z.null()
    ])),
    store_scope: z.optional(z.union([
        zParsedStoreScope,
        z.null()
    ])),
    cycle_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * ParseDescriptionIn
 */
export const zParseDescriptionIn = z.object({
    description: z.string()
});

/**
 * TranscribeOut
 */
export const zTranscribeOut = z.object({
    transcript: z.string()
});

/**
 * ParseVoiceOut
 */
export const zParseVoiceOut = z.object({
    project_type: z.union([
        z.string(),
        z.null()
    ]),
    category_name: z.union([
        z.string(),
        z.null()
    ]),
    category_id: z.union([
        z.uuid(),
        z.null()
    ]),
    cycle_week: z.union([
        z.int(),
        z.null()
    ]),
    plan_id: z.union([
        z.uuid(),
        z.null()
    ]),
    project_name: z.union([
        z.string(),
        z.null()
    ]),
    confidence: z.number(),
    date_range: z.optional(z.union([
        z.array(z.iso.date()),
        z.null()
    ])),
    store_scope: z.optional(z.union([
        zParsedStoreScope,
        z.null()
    ])),
    cycle_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    transcript: z.string()
});

/**
 * AnalyzeScopeV2Out
 *
 * Response of ``POST /wizard/{project_id}/analyze``.
 *
 * Inherits the full scope slot from :class:`ScopeSlotSchema`
 * and adds the project id for client convenience.
 */
export const zAnalyzeScopeV2Out = z.object({
    inputs_hash: z.string(),
    total_cycles: z.int(),
    cycles_with_work: z.int(),
    cycles_skipped: z.int(),
    total_categories: z.int(),
    total_eligible_stores: z.int(),
    total_nici_items: z.int(),
    category_ids: z.optional(z.array(z.uuid())),
    available_category_ids: z.optional(z.array(z.uuid())),
    cycles: z.array(zCycleSummaryOut),
    blockers: z.array(zBlockerOut),
    can_proceed: z.boolean(),
    warnings: z.array(z.string()),
    exceptions: z.optional(z.array(zScopeExceptionOut)),
    planning_input_version: z.optional(z.string()).default(''),
    rollover_included: z.optional(z.boolean()).default(false),
    project_id: z.uuid(),
    schedule_exceptions: z.optional(z.union([
        z.array(zScopeExceptionOut),
        z.null()
    ])),
    stale: z.optional(zStaleFlags)
});

/**
 * StoreAnalysis
 */
export const zStoreAnalysis = z.object({
    store_id: z.uuid(),
    code: z.string(),
    store_name: z.string(),
    segment: z.string(),
    square_footage: z.union([
        z.int(),
        z.null()
    ]),
    planogram_id: z.union([
        z.uuid(),
        z.null()
    ]),
    planogram_code: z.union([
        z.string(),
        z.null()
    ]),
    movement_count: z.int(),
    estimated_hours: z.number(),
    estimated_hours_low: z.number(),
    estimated_hours_high: z.number(),
    estimated_cost: z.number(),
    store_code: z.optional(z.string()).default('')
});

/**
 * AnalyzeScopeOut
 */
export const zAnalyzeScopeOut = z.object({
    total_stores: z.int(),
    total_estimated_hours: z.number(),
    total_estimated_cost: z.number(),
    planogram_segments: z.int(),
    hourly_rate: z.number(),
    stores: z.array(zStoreAnalysis)
});

/**
 * AnalyzeScopeIn
 */
export const zAnalyzeScopeIn = z.object({
    category_id: z.uuid(),
    project_type: z.string(),
    plan_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * ScheduleV2Out
 *
 * Response of POST /wizard/{project_id}/schedule and
 * /schedule/apply.
 */
export const zScheduleV2Out = z.object({
    inputs_hash: z.string(),
    total_cycles: z.int(),
    cycles_scheduled: z.int(),
    cycles_skipped: z.int(),
    total_work_days: z.int(),
    total_stores: z.int(),
    total_hours: z.number(),
    baseline_version: z.optional(z.int()).default(0),
    total_visits: z.optional(z.int()).default(0),
    total_work_hours: z.optional(z.number()).default(0),
    cycles: z.array(zCycleScheduleOut),
    unscheduled: z.optional(z.array(zUnscheduledStore)),
    warnings: z.optional(z.array(zScheduleWarning)),
    exceptions: z.optional(z.array(zScopeExceptionOut)),
    project_id: z.uuid(),
    updated_at: z.string(),
    scope: z.optional(z.union([
        zScopeSlotSchema,
        z.null()
    ]))
});

/**
 * ApplyScheduleOverridesIn
 *
 * Request body for POST /wizard/{project_id}/schedule/apply.
 *
 * Full-replacement semantics for the four schedule-level fields.
 * The endpoint preserves scope-level override fields
 * (category_ids, store_ids, notes, assignment_overrides,
 * nici_rollover_exclusions) untouched.
 */
export const zApplyScheduleOverridesIn = z.object({
    cycle_actions: z.optional(z.record(z.string(), z.enum(['skip', 'defer']))),
    category_moves: z.optional(z.array(zCategoryMoveOverride).max(1000)),
    schedule_on_holidays: z.optional(z.record(z.string(), z.boolean())),
    cycle_date_overrides: z.optional(z.record(z.string(), zCycleDateOverride))
});

/**
 * AssignTeamsV2Out
 *
 * Response of POST /wizard/{project_id}/assign-teams.
 */
export const zAssignTeamsV2Out = z.object({
    inputs_hash: z.string(),
    staffing_warnings: z.optional(z.array(zStaffingWarning)),
    total_assignments: z.int(),
    home_base_count: z.int(),
    team_rotation_count: z.int(),
    group_count: z.optional(z.int()).default(0),
    dynamic_count: z.int(),
    unassigned_count: z.int(),
    total_employees: z.int(),
    assignments: z.array(zCycleAssignment),
    unassigned: z.array(zUnassignedStore),
    employee_cycle_loads: z.array(zEmployeeCycleLoad),
    distance_warnings: z.array(zDistanceWarning),
    buddy_pairs: z.array(zBuddyPairInfo),
    cycle_summaries: z.optional(z.array(zCycleAssignmentSummary)),
    project_id: z.uuid(),
    updated_at: z.string()
});

/**
 * CostEstimateOut
 *
 * Response of POST /wizard/{project_id}/cost-estimate.
 */
export const zCostEstimateOut = z.object({
    inputs_hash: z.string(),
    total_labor_hours: z.number(),
    total_labor_cost: z.number(),
    unassigned_labor_hours: z.optional(z.number()).default(0),
    unassigned_labor_cost: z.optional(z.number()).default(0),
    total_miles: z.number(),
    total_mileage_cost: z.number(),
    total_estimated_cost: z.number(),
    stores_assigned: z.int(),
    stores_total: z.int(),
    store_coverage_pct: z.int(),
    field_team_count: z.int(),
    per_cycle: z.array(zCycleCostSummary),
    per_employee: z.array(zEmployeeCostSummary),
    warnings: z.array(zCostWarning),
    labor_rate_snapshot: z.optional(z.record(z.string(), z.unknown())),
    mileage_rate_snapshot: z.optional(z.record(z.string(), z.unknown())),
    project_id: z.uuid(),
    updated_at: z.string()
});

/**
 * WorkOrderOut
 */
export const zWorkOrderOut = z.object({
    id: z.uuid(),
    store_id: z.uuid(),
    assigned_employee_id: z.union([
        z.uuid(),
        z.null()
    ]),
    status: z.string(),
    scheduled_range: z.union([
        z.array(z.iso.date()),
        z.null()
    ]),
    estimated_hours: z.union([
        z.number(),
        z.null()
    ]),
    estimated_hours_low: z.union([
        z.number(),
        z.null()
    ]),
    estimated_hours_high: z.union([
        z.number(),
        z.null()
    ]),
    priority: z.int(),
    created_at: z.iso.datetime(),
    planogram_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    assigned_team_lead_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    scheduled_start_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ]))
});

/**
 * WizardCreateOut
 */
export const zWizardCreateOut = z.object({
    project: zProjectOut,
    work_orders_created: z.int(),
    work_orders: z.array(zWorkOrderOut)
});

/**
 * WorkOrderIn
 */
export const zWorkOrderIn = z.object({
    store_id: z.uuid(),
    assigned_employee_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    scheduled_range: z.optional(z.union([
        z.array(z.iso.date()),
        z.null()
    ])),
    estimated_hours: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_hours_low: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    estimated_hours_high: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    priority: z.optional(z.int()).default(0)
});

/**
 * WizardCreateIn
 */
export const zWizardCreateIn = z.object({
    name: z.string(),
    project_type: z.string(),
    description: z.optional(z.string()).default(''),
    estimated_labor_hours: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    work_orders: z.array(zWorkOrderIn)
});

/**
 * BuildWarningOut
 *
 * A non-fatal warning from project structure build.
 *
 * The three context fields are what make one actionable. Every
 * warning type the Reset build emits stands for work it declined to
 * create — no planogram, an anchor another project holds, a term
 * that has run out — and an operator told only that *something* was
 * declined has nowhere to look. Optional because not every producer
 * knows all three: a warning about a store with no work order names
 * no category.
 */
export const zBuildWarningOut = z.object({
    warning_type: z.string(),
    message: z.string(),
    store_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    category_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    cycle_number: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    scheduled_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    reason: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * BuildSummaryOut
 *
 * Counters from project structure materialisation.
 */
export const zBuildSummaryOut = z.object({
    visits_created: z.optional(z.int()).default(0),
    cycles_created: z.int(),
    cycles_skipped: z.int(),
    work_orders_created: z.int(),
    work_orders_unassigned: z.int(),
    work_items_created: z.int(),
    warnings: z.array(zBuildWarningOut)
});

/**
 * ApproveOut
 *
 * Response of POST /wizard/{project_id}/approve.
 */
export const zApproveOut = z.object({
    project: zProjectOut,
    build_summary: zBuildSummaryOut
});

/**
 * PreservedCycleOut
 */
export const zPreservedCycleOut = z.object({
    cycle_number: z.int(),
    name: z.string(),
    status: z.string()
});

/**
 * EditInitOut
 */
export const zEditInitOut = z.object({
    project_id: z.uuid(),
    base: z.record(z.string(), z.unknown()),
    cycle_offset: z.int(),
    future_start: z.iso.date(),
    preserved_cycles: z.array(zPreservedCycleOut)
});

/**
 * EditStateOut
 */
export const zEditStateOut = z.object({
    project_id: z.uuid(),
    active: z.boolean(),
    edit_state: z.optional(z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])),
    updated_at: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * EditSaveDraftIn
 */
export const zEditSaveDraftIn = z.object({
    date_range: z.tuple([z.iso.date(), z.iso.date()]),
    store_ids: z.optional(z.union([
        z.array(z.uuid()),
        z.null()
    ])),
    category_ids: z.optional(z.union([
        z.array(z.uuid()),
        z.null()
    ])),
    store_group_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * PreviewCycle
 *
 * Structural per-cycle change in an edit preview (no counts).
 */
export const zPreviewCycle = z.object({
    cycle_number: z.int(),
    name: z.string(),
    change: z.enum([
        'UNCHANGED',
        'CREATED',
        'DELETED',
        'MODIFIED',
        'PROTECTED'
    ]),
    effective_from: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    effective_to: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    reason: z.optional(z.string()).default('')
});

/**
 * EditPreview
 *
 * Structural preview of an edit (returned by ``analyze``).
 *
 * Carries which cycles will be created / deleted / modified /
 * protected, plus warnings and the commit gate — but NOT the
 * execution-row counts. Those are materialized only at ``commit``
 * (see ``EditCommitImpact``).
 */
export const zEditPreview = z.object({
    cycles: z.array(zPreviewCycle),
    cycles_created: z.int(),
    cycles_deleted: z.int(),
    cycles_modified: z.int(),
    cycles_unchanged: z.int(),
    protected_cycles: z.int(),
    warnings: z.optional(z.array(z.string())),
    blockers: z.optional(z.array(zBlockerOut)),
    can_commit: z.optional(z.boolean()).default(true)
});

/**
 * EditAnalyzeOut
 *
 * Response of ``POST /{id}/edit/analyze``.
 *
 * Keeps ``scope`` nested (alongside the delta ``preview``). The typed
 * ``ScopeSlotSchema`` drops backend-internal ``_*`` detail keys from
 * the response body — they remain in the persisted ``edit_state``.
 */
export const zEditAnalyzeOut = z.object({
    project_id: z.uuid(),
    updated_at: z.string(),
    scope: zScopeSlotSchema,
    preview: zEditPreview
});

/**
 * EditScheduleOut
 *
 * Response of ``POST /{id}/edit/schedule`` — schedule slot + ids.
 */
export const zEditScheduleOut = z.object({
    inputs_hash: z.string(),
    total_cycles: z.int(),
    cycles_scheduled: z.int(),
    cycles_skipped: z.int(),
    total_work_days: z.int(),
    total_stores: z.int(),
    total_hours: z.number(),
    baseline_version: z.optional(z.int()).default(0),
    total_visits: z.optional(z.int()).default(0),
    total_work_hours: z.optional(z.number()).default(0),
    cycles: z.array(zCycleScheduleOut),
    unscheduled: z.optional(z.array(zUnscheduledStore)),
    warnings: z.optional(z.array(zScheduleWarning)),
    exceptions: z.optional(z.array(zScopeExceptionOut)),
    project_id: z.uuid(),
    updated_at: z.string()
});

/**
 * EditAssignTeamsOut
 *
 * Response of ``POST /{id}/edit/assign-teams`` — assignment slot + ids.
 */
export const zEditAssignTeamsOut = z.object({
    inputs_hash: z.string(),
    staffing_warnings: z.optional(z.array(zStaffingWarning)),
    total_assignments: z.int(),
    home_base_count: z.int(),
    team_rotation_count: z.int(),
    group_count: z.optional(z.int()).default(0),
    dynamic_count: z.int(),
    unassigned_count: z.int(),
    total_employees: z.int(),
    assignments: z.array(zCycleAssignment),
    unassigned: z.array(zUnassignedStore),
    employee_cycle_loads: z.array(zEmployeeCycleLoad),
    distance_warnings: z.array(zDistanceWarning),
    buddy_pairs: z.array(zBuddyPairInfo),
    cycle_summaries: z.optional(z.array(zCycleAssignmentSummary)),
    project_id: z.uuid(),
    updated_at: z.string()
});

/**
 * EditCostOut
 *
 * Response of ``POST /{id}/edit/cost-estimate`` — cost slot + ids.
 */
export const zEditCostOut = z.object({
    inputs_hash: z.string(),
    total_labor_hours: z.number(),
    total_labor_cost: z.number(),
    unassigned_labor_hours: z.optional(z.number()).default(0),
    unassigned_labor_cost: z.optional(z.number()).default(0),
    total_miles: z.number(),
    total_mileage_cost: z.number(),
    total_estimated_cost: z.number(),
    stores_assigned: z.int(),
    stores_total: z.int(),
    store_coverage_pct: z.int(),
    field_team_count: z.int(),
    per_cycle: z.array(zCycleCostSummary),
    per_employee: z.array(zEmployeeCostSummary),
    warnings: z.array(zCostWarning),
    labor_rate_snapshot: z.optional(z.record(z.string(), z.unknown())),
    mileage_rate_snapshot: z.optional(z.record(z.string(), z.unknown())),
    project_id: z.uuid(),
    updated_at: z.string()
});

/**
 * CommitCycle
 *
 * Per-cycle change at commit, with materialized row counts.
 */
export const zCommitCycle = z.object({
    cycle_number: z.int(),
    name: z.string(),
    change: z.enum([
        'UNCHANGED',
        'CREATED',
        'DELETED',
        'MODIFIED',
        'PROTECTED'
    ]),
    effective_from: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    effective_to: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    work_orders_added: z.optional(z.int()).default(0),
    work_orders_removed: z.optional(z.int()).default(0),
    work_orders_kept: z.optional(z.int()).default(0),
    work_items_added: z.optional(z.int()).default(0),
    work_items_removed: z.optional(z.int()).default(0),
    work_items_kept: z.optional(z.int()).default(0),
    reason: z.optional(z.string()).default('')
});

/**
 * EditCommitImpact
 *
 * Materialized impact returned by ``commit``.
 *
 * Mirrors the wizard's ``BuildSummaryOut``: the real WorkOrder /
 * WorkItem counts of what was actually applied.
 */
export const zEditCommitImpact = z.object({
    cycles: z.array(zCommitCycle),
    cycles_created: z.int(),
    cycles_deleted: z.int(),
    cycles_modified: z.int(),
    cycles_unchanged: z.int(),
    protected_cycles: z.int(),
    work_orders_delta: z.record(z.string(), z.int()),
    work_items_delta: z.record(z.string(), z.int()),
    cost_before: z.optional(z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)).default('0'),
    cost_after: z.optional(z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)).default('0'),
    cost_diff: z.optional(z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)).default('0'),
    warnings: z.optional(z.array(z.string()))
});

/**
 * EditCommitOut
 */
export const zEditCommitOut = z.object({
    project_id: z.uuid(),
    applied_impact: zEditCommitImpact
});

/**
 * NiciScanListOut
 */
export const zNiciScanListOut = z.object({
    id: z.uuid(),
    task_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    visit_id: z.uuid(),
    work_item_id: z.union([
        z.uuid(),
        z.null()
    ]),
    scanned_by_id: z.uuid(),
    scanned_barcode: z.string(),
    product_id: z.union([
        z.uuid(),
        z.null()
    ]),
    is_matched: z.boolean(),
    scan_time_utc: z.iso.datetime(),
    quantity: z.int(),
    virtual_cart_id: z.union([
        z.uuid(),
        z.null()
    ]),
    scanner_source: z.string(),
    status: z.string(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * PaginatedNiciScanResponse
 */
export const zPaginatedNiciScanResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zNiciScanListOut)
});

/**
 * TaskType
 *
 * Activity type associated with a time entry.
 */
export const zTaskType = z.enum([
    'RESET',
    'NICI',
    'REMODEL',
    'ADMIN',
    'TRAVEL'
]);

/**
 * TimeEntryType
 *
 * Type of timekeeping event recorded by a field employee.
 */
export const zTimeEntryType = z.enum([
    'CLOCK_IN',
    'CLOCK_OUT',
    'BREAK_START',
    'BREAK_END',
    'TASK_START',
    'TASK_STOP'
]);

/**
 * TimeEntryOut
 */
export const zTimeEntryOut = z.object({
    id: z.uuid(),
    visit_id: z.uuid(),
    work_order_id: z.uuid(),
    work_item_id: z.union([
        z.uuid(),
        z.null()
    ]),
    employee_id: z.uuid(),
    entry_type: z.string(),
    task_type: z.string(),
    timestamp_utc: z.iso.datetime(),
    source: z.string(),
    created_at: z.iso.datetime()
});

/**
 * PaginatedTimeEntryResponse
 */
export const zPaginatedTimeEntryResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zTimeEntryOut)
});

/**
 * NiciPriceTagOutcome
 */
export const zNiciPriceTagOutcome = z.enum(['PLACED', 'ALREADY_PRESENT']);

/**
 * NiciResponseCode
 */
export const zNiciResponseCode = z.enum([
    'PRODUCT_PLACED',
    'ALREADY_ON_SHELF',
    'OOS'
]);

/**
 * NiciResolutionIn
 */
export const zNiciResolutionIn = z.object({
    response_code: zNiciResponseCode,
    price_tag_outcome: zNiciPriceTagOutcome,
    device_timestamp: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ]))
});

/**
 * CategoryStatsOut
 *
 * Response body for category aggregate statistics.
 *
 * Attributes:
 * total: Total number of categories.
 * by_level: Mapping of hierarchy level to the count
 * of categories at that level.
 */
export const zCategoryStatsOut = z.object({
    total: z.int(),
    by_level: z.record(z.string(), z.int())
});

/**
 * PaginatedCategoryResponse
 *
 * Paginated list of categories.
 *
 * Extends the standard paginated envelope with a typed
 * ``results`` list.
 *
 * Attributes:
 * count: Total number of matching records.
 * next: URL for the next page, or ``None``.
 * previous: URL for the previous page, or ``None``.
 * results: List of category records for the current page.
 */
export const zPaginatedCategoryResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zCategoryOut)
});

/**
 * CategoryIn
 *
 * Request body for creating a new category.
 *
 * Attributes:
 * code: External identifier from the retailer's
 * source system (PIM, ERP, WMS).
 * name: Human-readable category name.
 * parent_id: UUID of the parent category, or ``None``
 * to create a root node.
 * priority_score: AI-assigned priority for ordering
 * (1 = highest, 0 = unscored).
 */
export const zCategoryIn = z.object({
    code: z.optional(z.string()).default(''),
    name: z.optional(z.string()).default(''),
    parent_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    priority_score: z.optional(z.int()).default(0)
});

/**
 * CategoryPatch
 *
 * Request body for partially updating a category.
 *
 * All fields are optional; only fields present in the
 * request body will be applied (PATCH semantics).
 *
 * Attributes:
 * code: Updated external identifier.
 * name: Updated category name.
 * parent_id: Updated parent UUID, or ``None`` to make
 * the category a root node.
 * priority_score: Updated AI priority score.
 */
export const zCategoryPatch = z.object({
    code: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    parent_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    priority_score: z.optional(z.union([
        z.int(),
        z.null()
    ]))
});

/**
 * StoreStatsOut
 *
 * Aggregate store statistics.
 */
export const zStoreStatsOut = z.object({
    total: z.int(),
    by_segment: z.record(z.string(), z.int()),
    last_updated: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    active: z.optional(z.int()).default(0),
    inactive: z.optional(z.int()).default(0)
});

/**
 * LookupOut
 *
 * Output schema for lookup reference data.
 */
export const zLookupOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    is_active: z.boolean()
});

/**
 * RegionOut
 *
 * Output schema for a store hierarchy node exposed as a region.
 */
export const zRegionOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string()
});

/**
 * StoreGroupOut
 *
 * Output schema for a store group (scope picker).
 */
export const zStoreGroupOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    description: z.string(),
    status: z.string()
});

/**
 * StoreOut
 *
 * Output schema for a store.
 */
export const zStoreOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    address: z.string(),
    city: z.string(),
    state: z.string(),
    zip_code: z.string(),
    country: z.string(),
    timezone: z.union([
        z.string(),
        z.null()
    ]),
    segment_id: z.union([
        z.uuid(),
        z.null()
    ]),
    store_type_id: z.union([
        z.uuid(),
        z.null()
    ]),
    store_format_id: z.union([
        z.uuid(),
        z.null()
    ]),
    segment: z.optional(z.string()).default(''),
    store_type: z.optional(z.string()).default(''),
    store_format: z.optional(z.string()).default(''),
    square_footage: z.union([
        z.int(),
        z.null()
    ]),
    latitude: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    longitude: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    geofence_radius_m: z.int(),
    blackout_hours: z.record(z.string(), z.unknown()),
    status: z.string(),
    parent_hierarchy_node_id: z.union([
        z.uuid(),
        z.null()
    ]),
    parent_hierarchy_node_name: z.optional(z.string()).default(''),
    banner_id: z.union([
        z.uuid(),
        z.null()
    ]),
    manager_id: z.union([
        z.uuid(),
        z.null()
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    store_code: z.optional(z.string()).default(''),
    store_banner: z.optional(z.string()).default(''),
    manager_name: z.optional(z.string()).default(''),
    manager_phone: z.optional(z.string()).default(''),
    manager_email: z.optional(z.string()).default(''),
    hierarchy_node_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * PaginatedStoreResponse
 *
 * Paginated list of stores.
 */
export const zPaginatedStoreResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zStoreOut)
});

/**
 * StoreIn
 *
 * Input schema for creating a new store.
 */
export const zStoreIn = z.object({
    code: z.optional(z.string()).default(''),
    name: z.optional(z.string()).default(''),
    address: z.optional(z.string()).default(''),
    city: z.optional(z.string()).default(''),
    state: z.optional(z.string()).default(''),
    zip_code: z.optional(z.string()).default(''),
    country: z.optional(z.string()).default(''),
    timezone: z.optional(z.string()).default(''),
    segment_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    store_type_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    store_format_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    square_footage: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    latitude: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    longitude: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    geofence_radius_m: z.optional(z.int()).default(150),
    blackout_hours: z.optional(z.record(z.string(), z.unknown())).default({}),
    status: z.optional(z.string()).default('ACTIVE'),
    parent_hierarchy_node_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    banner_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    manager_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * StorePatch
 *
 * Input schema for partially updating a store.
 */
export const zStorePatch = z.object({
    code: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    address: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    city: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    state: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    zip_code: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    country: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    timezone: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    segment_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    store_type_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    store_format_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    square_footage: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    latitude: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    longitude: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    geofence_radius_m: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    blackout_hours: z.optional(z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])),
    status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    parent_hierarchy_node_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    banner_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    manager_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * EmployeeStatsOut
 */
export const zEmployeeStatsOut = z.object({
    total: z.int(),
    active: z.int(),
    inactive: z.int(),
    avg_stores_per_employee: z.number()
});

/**
 * EmploymentTypeOut
 */
export const zEmploymentTypeOut = z.object({
    code: z.string(),
    name: z.string(),
    max_daily_hours: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    max_weekly_hours: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
});

/**
 * EmployeeRoleOut
 */
export const zEmployeeRoleOut = z.object({
    code: z.string(),
    name: z.string()
});

/**
 * ActiveGroupOut
 */
export const zActiveGroupOut = z.object({
    id: z.uuid(),
    code: z.string()
});

/**
 * EmployeeOut
 */
export const zEmployeeOut = z.object({
    id: z.uuid(),
    first_name: z.string(),
    last_name: z.string(),
    contact_email: z.string(),
    phone_number: z.string(),
    status: z.string(),
    code: z.string(),
    assessment_score: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    employment_type: z.union([
        z.string(),
        z.null()
    ]),
    max_daily_hours: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    max_weekly_hours: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    travel_radius_miles: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    can_approve_overtime: z.boolean(),
    address: z.string(),
    city: z.string(),
    state: z.string(),
    zip_code: z.string(),
    home_latitude: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    home_longitude: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    geocoding_status: z.string(),
    supervisor_id: z.union([
        z.uuid(),
        z.null()
    ]),
    hire_date: z.union([
        z.iso.date(),
        z.null()
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    active_group: z.optional(z.union([
        zActiveGroupOut,
        z.null()
    ])),
    sms_otp_login_enabled: z.optional(z.boolean()).default(false),
    email_otp_login_enabled: z.optional(z.boolean()).default(false),
    application_sso_backend: z.optional(z.string()).default(''),
    name: z.optional(z.string()).default(''),
    email: z.optional(z.string()).default(''),
    phone: z.optional(z.string()).default(''),
    home_address: z.optional(z.string()).default(''),
    latitude: z.optional(z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    longitude: z.optional(z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    role: z.optional(z.string()).default(''),
    role_title: z.optional(z.string()).default(''),
    home_store_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * PaginatedEmployeeResponse
 */
export const zPaginatedEmployeeResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zEmployeeOut)
});

/**
 * EmployeeIn
 */
export const zEmployeeIn = z.object({
    first_name: z.string(),
    last_name: z.string(),
    contact_email: z.optional(z.string()).default(''),
    phone_number: z.optional(z.string()).default(''),
    hire_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    role: z.string(),
    status: z.optional(z.string()).default('ACTIVE'),
    code: z.optional(z.string()).default(''),
    assessment_score: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    employment_type: z.optional(z.string()).default(''),
    travel_radius_miles: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    can_approve_overtime: z.optional(z.boolean()).default(false),
    address: z.optional(z.string()).default(''),
    city: z.optional(z.string()).default(''),
    state: z.optional(z.string()).default(''),
    zip_code: z.optional(z.string()).default(''),
    home_latitude: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    home_longitude: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    sms_otp_login_enabled: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    email_otp_login_enabled: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    application_sso_backend: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * EmployeePatch
 */
export const zEmployeePatch = z.object({
    first_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    last_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    contact_email: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    phone_number: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    hire_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    role: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    code: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    assessment_score: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    employment_type: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    travel_radius_miles: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    can_approve_overtime: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    address: z.optional(z.string()).default(''),
    city: z.optional(z.string()).default(''),
    state: z.optional(z.string()).default(''),
    zip_code: z.optional(z.string()).default(''),
    home_latitude: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    home_longitude: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    sms_otp_login_enabled: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    email_otp_login_enabled: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    application_sso_backend: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * WorkItemBayOut
 */
export const zWorkItemBayOut = z.object({
    bay_id: z.string(),
    bay_number: z.int(),
    name: z.string(),
    state: z.string(),
    exception_reason: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    field_photo_id: z.union([
        z.uuid(),
        z.null()
    ]),
    image_url: z.string()
});

/**
 * VisitLocationAttemptOut
 */
export const zVisitLocationAttemptOut = z.object({
    id: z.uuid(),
    work_order_id: z.uuid(),
    store_id: z.uuid(),
    employee_id: z.uuid(),
    visit_id: z.union([
        z.uuid(),
        z.null()
    ]),
    attempt_type: z.string(),
    submitted_at: z.iso.datetime(),
    device_timestamp: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    latitude: z.number(),
    longitude: z.number(),
    accuracy_m: z.union([
        z.number(),
        z.null()
    ]),
    distance_to_store_m: z.union([
        z.number(),
        z.null()
    ]),
    within_geofence: z.boolean(),
    decision: z.string(),
    source: z.string(),
    request_id: z.string(),
    meta: z.record(z.string(), z.unknown()),
    geofence_radius_m: z.int(),
    store_has_location: z.boolean()
});

/**
 * VisitLocationAttemptIn
 */
export const zVisitLocationAttemptIn = z.object({
    latitude: z.number(),
    longitude: z.number(),
    accuracy_m: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    device_timestamp: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    attempt_type: z.optional(z.string()).default('CHECK_IN'),
    source: z.optional(z.string()).default('ONLINE'),
    request_id: z.optional(z.string()).default(''),
    meta: z.optional(z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ]))
});

/**
 * WorkItemSummaryOut
 */
export const zWorkItemSummaryOut = z.object({
    total: z.int(),
    pending: z.int(),
    in_progress: z.int(),
    completed: z.int(),
    partially_completed: z.int(),
    exception: z.int(),
    skipped: z.int(),
    not_found: z.int(),
    rolled_over: z.int()
});

/**
 * VisitStartOut
 */
export const zVisitStartOut = z.object({
    work_order_id: z.uuid(),
    work_order_status: z.string(),
    visit_id: z.uuid(),
    visit_status: z.string(),
    location_attempt_id: z.uuid(),
    check_in_time_utc: z.iso.datetime(),
    work_item_summary: zWorkItemSummaryOut,
    work_items: z.array(zWorkItemOut)
});

/**
 * StartVisitIn
 */
export const zStartVisitIn = z.object({
    device_timestamp: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ]))
});

/**
 * NiciTaskStartOut
 */
export const zNiciTaskStartOut = z.object({
    task_id: z.uuid(),
    can_resume: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    own_active_task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    work_order_id: z.uuid(),
    task_type: z.string(),
    visit_id: z.uuid(),
    time_entry_id: z.uuid(),
    task_started_at_utc: z.iso.datetime(),
    item_completion_proof_photo_required: z.boolean()
});

/**
 * NiciTaskTimingIn
 */
export const zNiciTaskTimingIn = z.object({
    task_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    device_timestamp: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ]))
});

/**
 * NiciScanOut
 */
export const zNiciScanOut = z.object({
    task_id: z.uuid(),
    scan_id: z.uuid(),
    work_item_id: z.union([
        z.uuid(),
        z.null()
    ]),
    product_id: z.union([
        z.uuid(),
        z.null()
    ]),
    work_item_status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    scanned_barcode: z.string(),
    detail: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * NiciScanIn
 */
export const zNiciScanIn = z.object({
    task_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    visit_id: z.uuid(),
    scanned_barcode: z.string(),
    scan_time_utc: z.iso.datetime(),
    quantity: z.optional(z.int()).default(1),
    scanner_source: z.string()
});

/**
 * NiciTaskStopOut
 */
export const zNiciTaskStopOut = z.object({
    task_id: z.uuid(),
    can_resume: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    own_active_task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    work_order_id: z.uuid(),
    task_type: z.string(),
    task_status: z.string(),
    on_shelf_completion_percentage: z.number(),
    items_on_shelf: z.int(),
    time_spent_minutes: z.int(),
    remaining_items: z.int()
});

/**
 * WorkItemStartOut
 */
export const zWorkItemStartOut = z.object({
    can_resume: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    own_active_task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    work_order_id: z.uuid(),
    visit_id: z.uuid(),
    visit_status: z.string(),
    work_item_id: z.uuid(),
    work_item_status: z.string(),
    time_entry_id: z.uuid(),
    task_started_at_utc: z.iso.datetime(),
    work_item: zWorkItemOut
});

/**
 * WorkItemStartIn
 */
export const zWorkItemStartIn = z.object({
    task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    device_timestamp: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ]))
});

/**
 * CompletionSummaryOut
 */
export const zCompletionSummaryOut = z.object({
    category_name: z.string(),
    work_item_id: z.uuid(),
    work_item_status: z.string(),
    pog_compliance_percent: z.union([
        z.number(),
        z.null()
    ]),
    required_bay_count: z.int(),
    captured_bay_count: z.int(),
    attempt_started_at_utc: z.iso.datetime(),
    submitted_at: z.iso.datetime(),
    time_spent_minutes: z.int(),
    actions_completed: z.int(),
    actions_remaining: z.union([
        z.int(),
        z.null()
    ]),
    history_quality: z.optional(z.string()).default('KNOWN'),
    total_required_actions: z.int(),
    total_completed_actions: z.int()
});

/**
 * WorkItemCompleteOut
 */
export const zWorkItemCompleteOut = z.object({
    can_resume: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    own_active_task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    work_item_id: z.uuid(),
    work_item_status: z.string(),
    task_completed_at_utc: z.iso.datetime(),
    work_item: zWorkItemOut
});

/**
 * WorkItemCompleteIn
 */
export const zWorkItemCompleteIn = z.object({
    task_attempt_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    device_timestamp: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ]))
});

/**
 * ProductStatsOut
 *
 * Response schema for aggregated product statistics.
 */
export const zProductStatsOut = z.object({
    total_skus: z.int(),
    category_count: z.int(),
    new_item_count: z.int(),
    active: z.optional(z.int()).default(0),
    discontinued: z.optional(z.int()).default(0)
});

/**
 * ProductBrandOut
 *
 * Response schema for a product brand lookup.
 */
export const zProductBrandOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string()
});

/**
 * ProductImageOut
 *
 * Response schema for a single product gallery image.
 */
export const zProductImageOut = z.object({
    id: z.uuid(),
    position: z.int(),
    is_primary: z.boolean(),
    url: z.optional(z.string()).default('')
});

/**
 * ProductOut
 *
 * Response schema for a single product.
 */
export const zProductOut = z.object({
    id: z.uuid(),
    barcode: z.string(),
    name: z.string(),
    code: z.string(),
    brand_id: z.union([
        z.uuid(),
        z.null()
    ]),
    manufacturer: z.string(),
    pack_size: z.string(),
    case_pack: z.union([
        z.int(),
        z.null()
    ]),
    width_inches: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    height_inches: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    depth_inches: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    weight_oz: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    retail_price: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    price_tag_code: z.string(),
    category_id: z.union([
        z.uuid(),
        z.null()
    ]),
    supplier_id: z.union([
        z.uuid(),
        z.null()
    ]),
    is_new_item: z.boolean(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    created_by_email: z.union([
        z.string(),
        z.null()
    ]),
    updated_by_email: z.union([
        z.string(),
        z.null()
    ]),
    import_batch_id: z.union([
        z.uuid(),
        z.null()
    ]),
    images: z.optional(z.array(zProductImageOut)).default([]),
    upc: z.optional(z.string()).default(''),
    retailer_product_id: z.optional(z.string()).default(''),
    description: z.optional(z.string()).default(''),
    brand: z.optional(z.string()).default(''),
    supplier_name: z.optional(z.string()).default(''),
    department_number: z.optional(z.string()).default(''),
    department_name: z.optional(z.string()).default(''),
    category_name: z.optional(z.string()).default(''),
    category_number: z.optional(z.string()).default(''),
    status: z.optional(z.string()).default('ACTIVE')
});

/**
 * PaginatedProductResponse
 *
 * Paginated list response wrapping :class:`ProductOut` items.
 */
export const zPaginatedProductResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zProductOut)
});

/**
 * ProductIn
 *
 * Request body for creating a new product.
 */
export const zProductIn = z.object({
    barcode: z.string(),
    name: z.string(),
    code: z.optional(z.string()).default(''),
    brand_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    manufacturer: z.optional(z.string()).default(''),
    pack_size: z.optional(z.string()).default(''),
    case_pack: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    width_inches: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    height_inches: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    depth_inches: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    weight_oz: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    retail_price: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    price_tag_code: z.optional(z.string().max(10)).default(''),
    category_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    supplier_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * ProductPatch
 *
 * Request body for partially updating a product.
 *
 * All fields are optional; only supplied fields are applied.
 */
export const zProductPatch = z.object({
    barcode: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    code: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    brand_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    manufacturer: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    pack_size: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    case_pack: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    width_inches: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    height_inches: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    depth_inches: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    weight_oz: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    retail_price: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    price_tag_code: z.optional(z.string().max(10)).default(''),
    category_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    supplier_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * PlanogramStatsOut
 */
export const zPlanogramStatsOut = z.object({
    total: z.int(),
    active: z.int(),
    variants: z.optional(z.int()).default(0),
    last_import: z.union([
        z.iso.datetime(),
        z.null()
    ])
});

/**
 * PlanogramOut
 */
export const zPlanogramOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    category_id: z.uuid(),
    version_number: z.int(),
    planogram_version_id: z.union([
        z.uuid(),
        z.null()
    ]),
    parent_planogram_id: z.union([
        z.uuid(),
        z.null()
    ]),
    status: z.string(),
    source: z.string(),
    store_segment_id: z.union([
        z.uuid(),
        z.null()
    ]),
    store_segment: z.optional(z.string()).default(''),
    image_id: z.union([
        z.uuid(),
        z.null()
    ]),
    source_file_id: z.union([
        z.uuid(),
        z.null()
    ]),
    total_width_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    total_height_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    total_depth_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    bay_count: z.union([
        z.int(),
        z.null()
    ]),
    shelf_count: z.union([
        z.int(),
        z.null()
    ]),
    position_count: z.union([
        z.int(),
        z.null()
    ]),
    sku_count: z.union([
        z.int(),
        z.null()
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    category_name: z.optional(z.string()).default(''),
    category_parent_name: z.union([
        z.string(),
        z.null()
    ]),
    parent_planogram_name: z.optional(z.string()).default(''),
    status_label: z.optional(z.string()).default(''),
    variant_code: z.optional(z.string()).default(''),
    segment: z.optional(z.string()).default(''),
    version: z.optional(z.int()).default(0),
    image_url: z.optional(z.string()).default(''),
    parent_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * PaginatedPlanogramResponse
 */
export const zPaginatedPlanogramResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zPlanogramOut)
});

/**
 * PlanogramIn
 */
export const zPlanogramIn = z.object({
    code: z.optional(z.string()).default(''),
    name: z.string(),
    category_id: z.uuid(),
    version_number: z.optional(z.int()).default(1),
    status: z.optional(z.string()).default('ACTIVE'),
    source: z.optional(z.string()).default(''),
    store_segment_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    parent_planogram_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * PlanogramPatch
 */
export const zPlanogramPatch = z.object({
    code: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    category_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    version_number: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    source: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    store_segment_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    parent_planogram_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    image_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    source_file_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * PlanogramDetailPositionOut
 */
export const zPlanogramDetailPositionOut = z.object({
    id: z.uuid(),
    sequence: z.int(),
    product_id: z.union([
        z.uuid(),
        z.null()
    ]),
    product_name: z.optional(z.string()).default(''),
    product_barcode: z.optional(z.string()).default(''),
    horizontal_facing: z.int(),
    vertical_facing: z.int(),
    depth_facing: z.int(),
    orientation: z.string(),
    merch_style: z.string(),
    x_offset_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    y_offset_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    width_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    height_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    depth_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])
});

/**
 * PlanogramShelfOut
 */
export const zPlanogramShelfOut = z.object({
    id: z.uuid(),
    number: z.int(),
    y_offset_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    width_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    depth_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    thickness_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    front_gap_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    type: z.string(),
    tilt_angle: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    position_count: z.optional(z.int()).default(0),
    positions: z.array(zPlanogramDetailPositionOut)
});

/**
 * PlanogramBayOut
 */
export const zPlanogramBayOut = z.object({
    id: z.uuid(),
    name: z.string(),
    sequence: z.int(),
    width_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    height_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    depth_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    x_offset_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    fixture_type: z.string(),
    notch_spacing_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    base_height_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    shelves: z.array(zPlanogramShelfOut)
});

/**
 * PlanogramDetailOut
 */
export const zPlanogramDetailOut = z.object({
    planogram: zPlanogramOut,
    bays: z.array(zPlanogramBayOut)
});

/**
 * PlanogramPositionProductOut
 */
export const zPlanogramPositionProductOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    barcode: z.string()
});

/**
 * PlanogramPositionOut
 */
export const zPlanogramPositionOut = z.object({
    id: z.uuid(),
    planogram_id: z.uuid(),
    bay_id: z.uuid(),
    shelf_id: z.uuid(),
    shelf_number: z.int(),
    product: z.union([
        zPlanogramPositionProductOut,
        z.null()
    ]),
    sequence: z.int(),
    facing_sequence: z.int(),
    x_offset_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    y_offset_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    width_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    height_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    depth_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    horizontal_facing: z.int(),
    vertical_facing: z.int(),
    depth_facing: z.int(),
    orientation: z.string(),
    merch_style: z.string(),
    gap_x_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    finger_space_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    peg_number: z.union([
        z.int(),
        z.null()
    ]),
    rank: z.union([
        z.int(),
        z.null()
    ]),
    on_shelf_position: z.string()
});

/**
 * PlanogramVersionVariantOut
 */
export const zPlanogramVersionVariantOut = z.object({
    id: z.uuid(),
    name: z.string(),
    code: z.string(),
    store_segment_id: z.union([
        z.uuid(),
        z.null()
    ]),
    status: z.string(),
    bay_count: z.union([
        z.int(),
        z.null()
    ]),
    position_count: z.union([
        z.int(),
        z.null()
    ]),
    store_count: z.int()
});

/**
 * PlanogramVersionDetailOut
 */
export const zPlanogramVersionDetailOut = z.object({
    id: z.uuid(),
    category_id: z.uuid(),
    version_number: z.int(),
    status: z.string(),
    effective_date: z.iso.date(),
    published_at: z.iso.datetime(),
    published_by_id: z.union([
        z.uuid(),
        z.null()
    ]),
    reset_cycle_id: z.union([
        z.uuid(),
        z.null()
    ]),
    based_on_version_id: z.union([
        z.uuid(),
        z.null()
    ]),
    store_count: z.int(),
    variants: z.array(zPlanogramVersionVariantOut)
});

/**
 * BayFixtureType
 *
 * Physical fixture type of a planogram bay.
 */
export const zBayFixtureType = z.enum([
    'GONDOLA',
    'ENDCAP',
    'WALL',
    'COOLER',
    'FREEZER',
    'PALLET',
    'CLIP_STRIP',
    'POWER_WING',
    'SIDEKICK'
]);

/**
 * MerchStyle
 *
 * Merchandising style that dictates how a product is displayed.
 */
export const zMerchStyle = z.enum([
    'STANDARD',
    'CASE',
    'STACKED',
    'LAY_FLAT',
    'PEGGED',
    'DUMP_BIN',
    'HANGING'
]);

/**
 * ProductOrientation
 *
 * Facing direction of a product on the shelf.
 */
export const zProductOrientation = z.enum([
    'FRONT',
    'LEFT',
    'RIGHT',
    'TOP',
    'BOTTOM',
    'BACK'
]);

/**
 * PublishPositionIn
 */
export const zPublishPositionIn = z.object({
    horizontal_facing: z.optional(z.int()).default(1),
    vertical_facing: z.optional(z.int()).default(1),
    depth_facing: z.optional(z.int()).default(1),
    sequence: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    product_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    x_offset_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    width_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    height_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    depth_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    orientation: z.optional(zProductOrientation).default('FRONT'),
    merch_style: z.optional(zMerchStyle).default('STANDARD')
});

/**
 * ShelfType
 *
 * Material or construction type of a shelf within a bay.
 */
export const zShelfType = z.enum([
    'REGULAR',
    'PEGBOARD',
    'BASKET',
    'WIRE',
    'GLASS',
    'DIVIDER'
]);

/**
 * PublishShelfIn
 */
export const zPublishShelfIn = z.object({
    number: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    y_offset_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    width_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    depth_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    type: z.optional(zShelfType).default('REGULAR'),
    positions: z.optional(z.array(zPublishPositionIn)).default([])
});

/**
 * PublishBayIn
 */
export const zPublishBayIn = z.object({
    name: z.string(),
    sequence: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    x_offset_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    width_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    height_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    depth_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    fixture_type: z.optional(z.union([
        zBayFixtureType,
        z.literal('')
    ])).default(''),
    shelves: z.optional(z.array(zPublishShelfIn)).default([])
});

/**
 * PublishVariantIn
 *
 * One variant of the version, with the layout it publishes.
 */
export const zPublishVariantIn = z.object({
    code: z.optional(z.string()).default(''),
    name: z.string(),
    store_segment_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    total_width_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    total_height_mm: z.optional(z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    bays: z.optional(z.array(zPublishBayIn)).default([])
});

/**
 * PublishVersionIn
 */
export const zPublishVersionIn = z.object({
    category_id: z.uuid(),
    effective_date: z.iso.date(),
    reset_cycle_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    variants: z.array(zPublishVariantIn)
});

/**
 * PlanogramVersionOut
 *
 * A published version.
 *
 * ``store_count`` is the family's reach *now*, not a figure frozen at
 * publication: it answers "how many stores does this version go to",
 * which is what §2 and §5 ask for. On an archived version it therefore
 * reports today's estate rather than the one it was published against.
 */
export const zPlanogramVersionOut = z.object({
    id: z.uuid(),
    category_id: z.uuid(),
    version_number: z.int(),
    status: z.string(),
    effective_date: z.iso.date(),
    published_at: z.iso.datetime(),
    published_by_id: z.union([
        z.uuid(),
        z.null()
    ]),
    reset_cycle_id: z.union([
        z.uuid(),
        z.null()
    ]),
    based_on_version_id: z.union([
        z.uuid(),
        z.null()
    ]),
    store_count: z.int()
});

/**
 * PaginatedPlanogramVersionResponse
 */
export const zPaginatedPlanogramVersionResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zPlanogramVersionOut)
});

/**
 * SegmentReachOut
 */
export const zSegmentReachOut = z.object({
    store_segment_id: z.union([
        z.uuid(),
        z.null()
    ]),
    store_count: z.int()
});

/**
 * StoreReachOut
 *
 * How many stores a publish would reach, before there is a version.
 */
export const zStoreReachOut = z.object({
    category_id: z.uuid(),
    store_count: z.int(),
    by_segment: z.array(zSegmentReachOut)
});

/**
 * VisualizationPlanogramOut
 */
export const zVisualizationPlanogramOut = z.object({
    id: z.uuid(),
    name: z.string(),
    version_number: z.int()
});

/**
 * VisualizationProductOut
 */
export const zVisualizationProductOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    barcode: z.string(),
    image_url: z.union([
        z.string(),
        z.null()
    ])
});

/**
 * VisualizationItemOut
 */
export const zVisualizationItemOut = z.object({
    item_id: z.uuid(),
    sequence: z.int(),
    facing_sequence: z.int(),
    shelf_number: z.int(),
    horizontal_facing: z.int(),
    vertical_facing: z.int(),
    depth_facing: z.int(),
    display_shelf_number: z.int(),
    display_sequence: z.int(),
    display_facing_sequence: z.int(),
    on_shelf_position: z.string(),
    x_offset_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    y_offset_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    width_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    height_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    depth_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    product: z.union([
        zVisualizationProductOut,
        z.null()
    ])
});

/**
 * VisualizationShelfOut
 */
export const zVisualizationShelfOut = z.object({
    id: z.uuid(),
    internal_number: z.int(),
    display_shelf_number: z.int(),
    y_offset_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    height_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    width_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    depth_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    thickness_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    front_gap_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    type: z.string(),
    tilt_angle: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    items: z.array(zVisualizationItemOut)
});

/**
 * VisualizationBayOut
 */
export const zVisualizationBayOut = z.object({
    id: z.uuid(),
    internal_sequence: z.int(),
    display_bay_label: z.string(),
    fixture_type: z.string(),
    width_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    height_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    depth_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    x_offset_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    notch_spacing_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    base_height_mm: z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ]),
    shelves: z.array(zVisualizationShelfOut)
});

/**
 * PlanogramVisualizationOut
 */
export const zPlanogramVisualizationOut = z.object({
    planogram: zVisualizationPlanogramOut,
    section_direction: z.string(),
    shelf_direction: z.string(),
    position_direction: z.string(),
    bays: z.array(zVisualizationBayOut)
});

/**
 * PolicyRuleStatsOut
 *
 * Aggregate policy rule statistics.
 */
export const zPolicyRuleStatsOut = z.object({
    total: z.int(),
    active: z.int(),
    inactive: z.int(),
    last_modified: z.union([
        z.iso.datetime(),
        z.null()
    ])
});

/**
 * PolicyRuleOut
 *
 * Output schema for a policy rule.
 */
export const zPolicyRuleOut = z.object({
    id: z.uuid(),
    name: z.string(),
    rule_type: z.string(),
    category: z.string(),
    scope_type: z.string(),
    scope_ref_id: z.union([
        z.uuid(),
        z.null()
    ]),
    region: z.string(),
    condition: z.record(z.string(), z.unknown()),
    action: z.string(),
    action_params: z.record(z.string(), z.unknown()),
    raw_text: z.string(),
    priority: z.int(),
    effective_range: z.union([
        z.record(z.string(), z.union([
            z.iso.date(),
            z.null()
        ])),
        z.null()
    ]),
    is_active: z.boolean(),
    created_by_id: z.union([
        z.uuid(),
        z.null()
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * PaginatedPolicyRuleResponse
 *
 * Paginated list of policy rules.
 */
export const zPaginatedPolicyRuleResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zPolicyRuleOut)
});

/**
 * PolicyRuleIn
 *
 * Input schema for creating a policy rule.
 */
export const zPolicyRuleIn = z.object({
    name: z.string(),
    rule_type: z.string(),
    category: z.string(),
    scope_type: z.string(),
    scope_ref_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    region: z.optional(z.string()).default(''),
    condition: z.record(z.string(), z.unknown()),
    action: z.string(),
    action_params: z.optional(z.record(z.string(), z.unknown())).default({}),
    raw_text: z.optional(z.string()).default(''),
    priority: z.int(),
    effective_range: z.optional(z.union([
        z.record(z.string(), z.union([
            z.iso.date(),
            z.null()
        ])),
        z.null()
    ])),
    is_active: z.optional(z.boolean()).default(true),
    created_by_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * PolicyRulePatch
 *
 * Input schema for partially updating a policy rule.
 */
export const zPolicyRulePatch = z.object({
    name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    rule_type: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    category: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    scope_type: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    scope_ref_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    region: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    condition: z.optional(z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])),
    action: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    action_params: z.optional(z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])),
    raw_text: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    priority: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    effective_range: z.optional(z.union([
        z.record(z.string(), z.union([
            z.iso.date(),
            z.null()
        ])),
        z.null()
    ])),
    is_active: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    created_by_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * SupplierOut
 *
 * Response schema for a supplier lookup.
 */
export const zSupplierOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string()
});

/**
 * StoreCategoryStatsOut
 */
export const zStoreCategoryStatsOut = z.object({
    total_mappings: z.int(),
    complete: z.int(),
    missing: z.int(),
    last_sync: z.union([
        z.iso.datetime(),
        z.null()
    ])
});

/**
 * CategoryLocationSide
 *
 * Which side of the aisle a category occupies.
 */
export const zCategoryLocationSide = z.enum(['LEFT', 'RIGHT']);

/**
 * StoreCategoryOut
 */
export const zStoreCategoryOut = z.object({
    id: z.uuid(),
    store_id: z.uuid(),
    category_id: z.uuid(),
    fixture_type_id: z.union([
        z.uuid(),
        z.null()
    ]),
    planogram_id: z.union([
        z.uuid(),
        z.null()
    ]),
    zone: z.string(),
    aisle_number: z.string(),
    side: z.union([
        zCategoryLocationSide,
        z.literal('')
    ]),
    bay_range: z.string(),
    linear_footage: z.union([
        z.number(),
        z.null()
    ]),
    last_reset_date: z.union([
        z.iso.date(),
        z.null()
    ]),
    is_active: z.boolean(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    store_name: z.optional(z.string()).default(''),
    category_name: z.optional(z.string()).default(''),
    planogram_name: z.optional(z.string()).default(''),
    assigned: z.optional(z.boolean()).default(false),
    effective_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ]))
});

/**
 * PaginatedStoreCategoryResponse
 */
export const zPaginatedStoreCategoryResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zStoreCategoryOut)
});

/**
 * StoreCategoryIn
 */
export const zStoreCategoryIn = z.object({
    store_id: z.uuid(),
    category_id: z.uuid(),
    fixture_type_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    planogram_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    zone: z.optional(z.string()).default(''),
    aisle_number: z.optional(z.string()).default(''),
    side: z.optional(z.union([
        zCategoryLocationSide,
        z.literal('')
    ])).default(''),
    bay_range: z.optional(z.string()).default(''),
    linear_footage: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    last_reset_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    is_active: z.optional(z.boolean()).default(true)
});

/**
 * StoreCategoryPatch
 */
export const zStoreCategoryPatch = z.object({
    store_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    category_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    fixture_type_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    planogram_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    zone: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    aisle_number: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    side: z.optional(z.union([
        zCategoryLocationSide,
        z.literal(''),
        z.null()
    ])),
    bay_range: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    linear_footage: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    last_reset_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    is_active: z.optional(z.union([
        z.boolean(),
        z.null()
    ]))
});

/**
 * StorePlanogramStatsOut
 */
export const zStorePlanogramStatsOut = z.object({
    total_assignments: z.int(),
    active: z.int(),
    pending: z.int(),
    expired: z.int()
});

/**
 * StorePlanogramGroupStatsOut
 */
export const zStorePlanogramGroupStatsOut = z.object({
    mapped_planograms: z.int(),
    assigned_stores: z.int(),
    assignments_missing_location: z.int()
});

/**
 * StorePlanogramGroupOut
 */
export const zStorePlanogramGroupOut = z.object({
    planogram_id: z.uuid(),
    code: z.string(),
    name: z.string(),
    version_number: z.int(),
    status: z.string(),
    status_label: z.optional(z.string()).default(''),
    category_id: z.uuid(),
    category_name: z.string(),
    store_count: z.int(),
    assignment_count: z.int(),
    assignments_with_location: z.int()
});

/**
 * PaginatedStorePlanogramGroupResponse
 */
export const zPaginatedStorePlanogramGroupResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zStorePlanogramGroupOut)
});

/**
 * StorePlanogramLocationOut
 */
export const zStorePlanogramLocationOut = z.object({
    zone: z.string(),
    aisle: z.string(),
    side: z.string(),
    bay_section_number: z.string()
});

/**
 * StorePlanogramOut
 */
export const zStorePlanogramOut = z.object({
    id: z.uuid(),
    store_id: z.uuid(),
    planogram_id: z.uuid(),
    category_id: z.uuid(),
    effective_range: z.union([
        z.record(z.string(), z.union([
            z.iso.date(),
            z.null()
        ])),
        z.null()
    ]),
    source: z.string(),
    section_direction: z.string(),
    shelf_direction: z.string(),
    product_position_direction: z.string(),
    segment_match: z.string(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    store_name: z.optional(z.string()).default(''),
    store_city: z.optional(z.string()).default(''),
    store_state: z.optional(z.string()).default(''),
    store_region_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    store_region_name: z.optional(z.string()).default(''),
    planogram_name: z.optional(z.string()).default(''),
    category_name: z.optional(z.string()).default(''),
    locations: z.optional(z.array(zStorePlanogramLocationOut)).default([]),
    location_groups: z.optional(z.array(z.string())).default([]),
    effective_from: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    effective_to: z.optional(z.union([
        z.iso.date(),
        z.null()
    ]))
});

/**
 * PaginatedStorePlanogramResponse
 */
export const zPaginatedStorePlanogramResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zStorePlanogramOut)
});

/**
 * StorePlanogramIn
 */
export const zStorePlanogramIn = z.object({
    store_id: z.uuid(),
    planogram_id: z.uuid(),
    category_id: z.uuid(),
    effective_range: z.record(z.string(), z.union([
        z.iso.date(),
        z.null()
    ])),
    source: z.optional(z.string()).default(''),
    section_direction: z.optional(z.string()).default('LEFT_TO_RIGHT'),
    shelf_direction: z.optional(z.string()).default('BOTTOM_UP'),
    product_position_direction: z.optional(z.string()).default('LEFT_TO_RIGHT')
});

/**
 * StorePlanogramPatch
 */
export const zStorePlanogramPatch = z.object({
    store_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    planogram_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    category_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    effective_range: z.optional(z.union([
        z.record(z.string(), z.union([
            z.iso.date(),
            z.null()
        ])),
        z.null()
    ])),
    source: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    section_direction: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    shelf_direction: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    product_position_direction: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * StoreProductStatsOut
 */
export const zStoreProductStatsOut = z.object({
    total_distributions: z.int(),
    active: z.int(),
    new_items: z.int(),
    last_sync: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    out_of_stock: z.optional(z.int()).default(0)
});

/**
 * StoreProductOut
 */
export const zStoreProductOut = z.object({
    id: z.uuid(),
    store_id: z.uuid(),
    product_id: z.uuid(),
    hierarchy_node_id: z.union([
        z.uuid(),
        z.null()
    ]),
    item_status: z.string(),
    supply_channel: z.string(),
    effective_range: z.union([
        z.record(z.string(), z.union([
            z.iso.date(),
            z.null()
        ])),
        z.null()
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    store_name: z.optional(z.string()).default(''),
    product_name: z.optional(z.string()).default(''),
    distributed: z.optional(z.boolean()).default(false),
    last_order_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    quantity_on_hand: z.optional(z.int()).default(0),
    status: z.optional(z.string()).default('')
});

/**
 * PaginatedStoreProductResponse
 */
export const zPaginatedStoreProductResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zStoreProductOut)
});

/**
 * StoreProductIn
 */
export const zStoreProductIn = z.object({
    store_id: z.uuid(),
    product_id: z.uuid(),
    hierarchy_node_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    item_status: z.optional(z.string()).default('V'),
    supply_channel: z.optional(z.string()).default('W'),
    effective_range: z.optional(z.union([
        z.record(z.string(), z.union([
            z.iso.date(),
            z.null()
        ])),
        z.null()
    ]))
});

/**
 * StoreProductPatch
 */
export const zStoreProductPatch = z.object({
    store_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    product_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    hierarchy_node_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    item_status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    supply_channel: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    effective_range: z.optional(z.union([
        z.record(z.string(), z.union([
            z.iso.date(),
            z.null()
        ])),
        z.null()
    ]))
});

/**
 * ChoiceOut
 *
 * Serialized form of a ``TextChoices`` / enum field value.
 *
 * Every API that returns a choice-typed field should wrap the raw
 * value in this shape so clients get both the stable machine code
 * and a human-readable label without extra round-trips.
 *
 * Attributes:
 * code: Raw enum value (e.g. ``"HOME_BASE"``).
 * name: Human-readable display name (e.g. ``"Home Base"``).
 */
export const zChoiceOut = z.object({
    code: z.string(),
    name: z.string()
});

/**
 * EmployeeNestedOut
 *
 * Subset of ``employees.Employee`` surfaced inside an assignment
 * payload.
 */
export const zEmployeeNestedOut = z.object({
    id: z.uuid(),
    first_name: z.string(),
    last_name: z.string(),
    role: z.union([
        zChoiceOut,
        z.null()
    ]),
    role_title: z.optional(z.union([
        zChoiceOut,
        z.null()
    ])),
    contact_email: z.string(),
    status: zChoiceOut
});

/**
 * StoreNestedOut
 *
 * Subset of ``stores.Store`` surfaced inside an assignment payload.
 */
export const zStoreNestedOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    city: z.string(),
    state: z.string(),
    status: zChoiceOut
});

/**
 * EmployeeStoreAssignmentOut
 *
 * One employee-store assignment as returned to the client.
 */
export const zEmployeeStoreAssignmentOut = z.object({
    id: z.uuid(),
    assignment_type: zChoiceOut,
    is_primary: z.boolean(),
    effective_from: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    effective_to: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    effective_range: z.optional(z.union([
        z.record(z.string(), z.union([
            z.iso.date(),
            z.null()
        ])),
        z.null()
    ])),
    status: zChoiceOut,
    notes: z.string(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    store: zStoreNestedOut,
    employee: zEmployeeNestedOut
});

/**
 * PaginatedEmployeeStoreAssignmentResponse
 *
 * Paginated envelope for the assignments list endpoint.
 */
export const zPaginatedEmployeeStoreAssignmentResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zEmployeeStoreAssignmentOut)
});

/**
 * EmployeeStoreAssignmentIn
 *
 * Request body for POST /employee-store-assignments/.
 */
export const zEmployeeStoreAssignmentIn = z.object({
    employee_id: z.uuid(),
    store_id: z.uuid(),
    assignment_type: z.string(),
    is_primary: z.optional(z.boolean()).default(false),
    effective_range: z.record(z.string(), z.union([
        z.iso.date(),
        z.null()
    ])),
    notes: z.optional(z.string()).default('')
});

/**
 * EmployeeStoreAssignmentByTypeOut
 *
 * Nested ``by_type`` block inside the stats response.
 */
export const zEmployeeStoreAssignmentByTypeOut = z.object({
    home_base: z.int(),
    team_rotation: z.int(),
    buddy_pair: z.int()
});

/**
 * EmployeeStoreAssignmentStatsOut
 *
 * Aggregated counters for assignments matching a filter set.
 */
export const zEmployeeStoreAssignmentStatsOut = z.object({
    total_assignments: z.int(),
    primary: z.int(),
    secondary: z.int(),
    by_type: zEmployeeStoreAssignmentByTypeOut
});

/**
 * EmployeeStoreAssignmentPatch
 *
 * Request body for PATCH /employee-store-assignments/{id}.
 *
 * All fields optional; only provided fields are applied.
 */
export const zEmployeeStoreAssignmentPatch = z.object({
    employee_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    store_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    assignment_type: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    is_primary: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    effective_range: z.optional(z.union([
        z.record(z.string(), z.union([
            z.iso.date(),
            z.null()
        ])),
        z.null()
    ])),
    notes: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * WorkingGroupStatus
 *
 * Whether a working group takes part in Group-mode scheduling.
 */
export const zWorkingGroupStatus = z.enum(['ACTIVE', 'INACTIVE']);

/**
 * HomeBaseStoreOut
 */
export const zHomeBaseStoreOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string()
});

/**
 * WorkingGroupMemberOut
 */
export const zWorkingGroupMemberOut = z.object({
    employee_id: z.uuid(),
    first_name: z.string(),
    last_name: z.string(),
    contact_email: z.string(),
    is_lead: z.boolean()
});

/**
 * WorkingGroupOut
 */
export const zWorkingGroupOut = z.object({
    id: z.uuid(),
    code: z.string(),
    status: zChoiceOut,
    members: z.array(zWorkingGroupMemberOut),
    home_base_stores: z.array(zHomeBaseStoreOut)
});

/**
 * PaginatedWorkingGroupResponse
 */
export const zPaginatedWorkingGroupResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zWorkingGroupOut)
});

/**
 * WorkingGroupIn
 */
export const zWorkingGroupIn = z.object({
    member_ids: z.array(z.uuid()),
    lead_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    status: z.optional(zWorkingGroupStatus).default('ACTIVE')
});

/**
 * WorkingGroupStatsOut
 */
export const zWorkingGroupStatsOut = z.object({
    active_groups: z.int(),
    active_members: z.int(),
    home_base_stores_covered: z.int(),
    inactive_groups: z.int()
});

/**
 * WorkingGroupPatch
 *
 * Only the provided fields change.
 */
export const zWorkingGroupPatch = z.object({
    member_ids: z.optional(z.union([
        z.array(z.uuid()),
        z.null()
    ])),
    lead_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    status: z.optional(z.union([
        zWorkingGroupStatus,
        z.null()
    ]))
});

/**
 * CycleStatsOut
 */
export const zCycleStatsOut = z.object({
    current_cycle: z.union([
        z.int(),
        z.null()
    ]),
    upcoming_cycles: z.int(),
    missing_estimates: z.int()
});

/**
 * PaginatedCycleResponse
 */
export const zPaginatedCycleResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zCycleOut)
});

/**
 * CycleIn
 */
export const zCycleIn = z.object({
    cycle_name: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    week_number: z.optional(z.union([
        z.int(),
        z.null()
    ]))
});

/**
 * CycleCategoryIn
 */
export const zCycleCategoryIn = z.object({
    category_id: z.uuid(),
    estimated_hours: z.number().gte(0.01).lte(999999.99),
    priority_score: z.optional(z.union([
        z.int().gte(0).lte(2147483647),
        z.null()
    ]))
});

/**
 * CyclePatch
 */
export const zCyclePatch = z.object({
    cycle_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    start_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    end_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    week_number: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    category_ids: z.optional(z.union([
        z.array(z.uuid()),
        z.null()
    ])),
    categories: z.optional(z.union([
        z.array(zCycleCategoryIn),
        z.null()
    ]))
});

/**
 * NICIStatsOut
 */
export const zNiciStatsOut = z.object({
    total_items: z.int(),
    this_month: z.int()
});

/**
 * NICICategoryRef
 *
 * Minimal category summary embedded in NICI list/detail responses.
 */
export const zNiciCategoryRef = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string()
});

/**
 * NICIProductRef
 *
 * Minimal product summary embedded in NICI list/detail responses.
 */
export const zNiciProductRef = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    barcode: z.string()
});

/**
 * NICIStoreRef
 *
 * Minimal store summary embedded in NICI list/detail responses.
 */
export const zNiciStoreRef = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string()
});

/**
 * NICIOut
 */
export const zNiciOut = z.object({
    id: z.uuid(),
    product_id: z.uuid(),
    product: zNiciProductRef,
    category_id: z.union([
        z.uuid(),
        z.null()
    ]),
    category: z.union([
        zNiciCategoryRef,
        z.null()
    ]),
    store_id: z.uuid(),
    store: zNiciStoreRef,
    effective_from: z.iso.date(),
    effective_to: z.union([
        z.iso.date(),
        z.null()
    ]),
    priority: z.union([
        z.string(),
        z.null()
    ]),
    authorization_id: z.union([
        z.uuid(),
        z.null()
    ]),
    status: z.enum([
        'SCHEDULED',
        'IN_PROGRESS',
        'COMPLETED'
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * PaginatedNICIResponse
 */
export const zPaginatedNiciResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zNiciOut)
});

/**
 * NICIBulkConflict
 *
 * GiST overlap with an existing listing for the same product/store.
 */
export const zNiciBulkConflict = z.object({
    store_id: z.uuid(),
    store: zNiciStoreRef,
    detail: z.string()
});

/**
 * NICIBulkFailed
 *
 * The ``store_id`` was not found; no listing was attempted.
 */
export const zNiciBulkFailed = z.object({
    store_id: z.uuid(),
    store: z.optional(z.null()),
    detail: z.string()
});

/**
 * NICIBulkResult
 */
export const zNiciBulkResult = z.object({
    created: z.array(zNiciOut),
    conflicts: z.array(zNiciBulkConflict),
    failed: z.array(zNiciBulkFailed)
});

/**
 * NICIIn
 */
export const zNiciIn = z.object({
    product_id: z.uuid(),
    store_ids: z.array(z.uuid()),
    authorization_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    effective_from: z.iso.date(),
    effective_to: z.optional(z.union([
        z.iso.date(),
        z.null()
    ]))
});

/**
 * NICIPatch
 */
export const zNiciPatch = z.object({
    product_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    store_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    authorization_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    effective_from: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    effective_to: z.optional(z.union([
        z.iso.date(),
        z.null()
    ]))
});

/**
 * PresignedFormOut
 *
 * Presigned POST form data returned by the storage provider.
 */
export const zPresignedFormOut = z.object({
    url: z.string(),
    fields: z.record(z.string(), z.string()),
    fields_order: z.array(z.string()),
    provider: z.string()
});

/**
 * RequestUploadOut
 *
 * Output schema for a created upload request.
 */
export const zRequestUploadOut = z.object({
    id: z.uuid(),
    folder: z.string(),
    original_name: z.string(),
    mime_type: z.string(),
    file_size: z.int(),
    state: z.string(),
    upload_form: zPresignedFormOut,
    created_at: z.iso.datetime()
});

/**
 * RequestUploadIn
 *
 * Input schema for requesting a presigned upload form.
 */
export const zRequestUploadIn = z.object({
    folder: z.string(),
    original_name: z.string().min(1).max(255),
    mime_type: z.string().min(1).max(100),
    file_size: z.int().gt(0),
    checksum: z.string(),
    description: z.optional(z.string()).default('')
});

/**
 * ComplianceProductActionType
 *
 * Action the compliance pipeline recommends for a product.
 */
export const zComplianceProductActionType = z.enum([
    'KEEP',
    'MOVE',
    'REMOVE',
    'RESTOCK',
    'INCREASE_FACINGS',
    'REDUCE_FACINGS',
    'IDENTIFY'
]);

/**
 * ComplianceProductOut
 *
 * Product reference inside an action row.
 *
 * Named distinctly from ``products.schemas.ProductOut`` to avoid an
 * OpenAPI ``components.schemas`` namespace collision.
 */
export const zComplianceProductOut = z.object({
    id: z.uuid(),
    name: z.string(),
    barcode: z.string(),
    image_url: z.union([
        z.string(),
        z.null()
    ])
});

/**
 * ProductActionCompletionOutcome
 *
 * Define completion outcome codes for the product-action API only.
 *
 * Persisted resolutions use a response option and a separate price-tag
 * outcome instead of this public enum.
 */
export const zProductActionCompletionOutcome = z.enum(['PERFORMED', 'OOS_PRICE_TAG_PLACED']);

/**
 * ProductActionOut
 *
 * One row of the per-WorkItem product-actions list.
 *
 * ``from_`` is aliased to the wire name ``from`` because ``from`` is
 * a Python keyword.
 */
export const zProductActionOut = z.object({
    id: z.uuid(),
    work_item_id: z.union([
        z.uuid(),
        z.null()
    ]),
    action_type: z.string(),
    action_state: z.string(),
    status: z.string(),
    from: z.string(),
    to: z.string(),
    product: zComplianceProductOut,
    bay_id: z.uuid(),
    bay_sequence: z.int(),
    bay_name: z.string(),
    completion_outcome: z.optional(z.union([
        zProductActionCompletionOutcome,
        z.null()
    ]))
});

/**
 * PaginatedProductActionsOut
 *
 * Paginated list of product actions.
 */
export const zPaginatedProductActionsOut = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zProductActionOut)
});

/**
 * ProductActionsPostResetPhotoStateOut
 */
export const zProductActionsPostResetPhotoStateOut = z.object({
    is_new_after_photo_required: z.boolean()
});

/**
 * ProductActionMutationOut
 */
export const zProductActionMutationOut = z.object({
    product_action_id: z.uuid(),
    action_state: z.string(),
    work_item: zWorkItemOut,
    completion_outcome: z.optional(z.union([
        zProductActionCompletionOutcome,
        z.null()
    ])),
    time_entry_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    exception_event_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * ErrorResponse
 *
 * Standard error response body.
 *
 * Attributes:
 * detail: Human-readable error description.
 */
export const zErrorResponse = z.object({
    detail: z.string()
});

/**
 * ProductActionPatchIn
 *
 * Reopen a completed product action in the active RESET attempt.
 */
export const zProductActionPatchIn = z.object({
    action_state: z.literal('IDLE')
});

/**
 * ProductActionCompleteIn
 *
 * Complete one product action with an optional explicit outcome.
 *
 * Omit ``completion_outcome`` or send ``null`` to preserve the legacy
 * completion request, which records ``PERFORMED`` for a newly open action.
 * A conflicting explicit outcome returns HTTP 409 and must be shown to the
 * user rather than retried with a different outcome. The OOS outcome is
 * available only for RESTOCK and records that its price tag was placed.
 */
export const zProductActionCompleteIn = z.object({
    work_item_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    device_timestamp: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    completion_outcome: z.optional(z.union([
        zProductActionCompletionOutcome,
        z.null()
    ]))
});

/**
 * BulkProductActionMutationOut
 */
export const zBulkProductActionMutationOut = z.object({
    results: z.array(zProductActionMutationOut),
    work_items: z.array(zWorkItemOut),
    time_entry_ids: z.array(z.uuid())
});

/**
 * BulkProductActionCompleteIn
 */
export const zBulkProductActionCompleteIn = z.object({
    product_action_ids: z.array(z.uuid()),
    work_item_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    device_timestamp: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ]))
});

/**
 * PogCategoryRateOut
 */
export const zPogCategoryRateOut = z.object({
    rate: z.union([
        z.number(),
        z.null()
    ]),
    measured_stores: z.int(),
    category_id: z.uuid()
});

/**
 * PogPlanogramRateOut
 */
export const zPogPlanogramRateOut = z.object({
    rate: z.union([
        z.number(),
        z.null()
    ]),
    measured_stores: z.int(),
    planogram_id: z.uuid()
});

/**
 * PogCategoryRateDetailOut
 *
 * A category's rate and each of its variants'.
 *
 * The category rate is pooled across every measured store in the
 * category, not averaged from ``variants``, which cover different
 * numbers of stores.
 */
export const zPogCategoryRateDetailOut = z.object({
    rate: z.union([
        z.number(),
        z.null()
    ]),
    measured_stores: z.int(),
    category_id: z.uuid(),
    variants: z.array(zPogPlanogramRateOut)
});

/**
 * PogStoreRateOut
 *
 * One store's latest POG compliance for a single planogram.
 *
 * ``project_id`` and ``planning_cycle_id`` are the reset that produced the
 * figure, so a caller can link the store to that visit. Both are null
 * only where no active result backs the rollup.
 */
export const zPogStoreRateOut = z.object({
    store_id: z.uuid(),
    rate: z.union([
        z.number(),
        z.null()
    ]),
    measured_on: z.iso.date(),
    project_id: z.union([
        z.uuid(),
        z.null()
    ]),
    planning_cycle_id: z.union([
        z.uuid(),
        z.null()
    ])
});

/**
 * SourceOut
 *
 * Minimal ingestion source info embedded in run-log responses.
 */
export const zSourceOut = z.object({
    id: z.uuid(),
    name: z.string(),
    delivery_method: z.string()
});

/**
 * ImportRunOut
 *
 * List / create response — one ingestion run.
 */
export const zImportRunOut = z.object({
    id: z.uuid(),
    status: z.string(),
    data_type: z.optional(z.string()).default(''),
    file_name: z.optional(z.string()).default(''),
    source_rows: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    records_total: z.union([
        z.int(),
        z.null()
    ]),
    records_processed: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    records_created: z.union([
        z.int(),
        z.null()
    ]),
    records_updated: z.union([
        z.int(),
        z.null()
    ]),
    records_skipped: z.union([
        z.int(),
        z.null()
    ]),
    records_errored: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    errors_truncated: z.optional(z.boolean()).default(false),
    error_summary: z.unknown(),
    started_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    completed_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    source: zSourceOut,
    name: z.optional(z.string()).default(''),
    delivery_method: z.optional(z.string()).default(''),
    schedule: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    is_active: z.optional(z.boolean()).default(true),
    source_type: z.optional(z.string()).default(''),
    adapter_class: z.optional(z.string()).default(''),
    filename: z.optional(z.string()).default(''),
    file_hash: z.optional(z.string()).default(''),
    row_count: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    error_message: z.optional(z.string()).default(''),
    rows_processed: z.optional(z.int()).default(0),
    rows_failed: z.optional(z.int()).default(0),
    rows_skipped: z.optional(z.int()).default(0),
    exceptions_json: z.optional(z.unknown())
});

/**
 * PaginatedImportRunResponse
 */
export const zPaginatedImportRunResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zImportRunOut)
});

/**
 * ImportRunCreateOut
 *
 * Minimal response returned immediately after creating a run.
 */
export const zImportRunCreateOut = z.object({
    id: z.uuid(),
    status: z.string(),
    file_name: z.optional(z.string()).default(''),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    source: zSourceOut
});

/**
 * ApproveImportIn
 *
 * Human decision on a paused mapping approval.
 *
 * ``decision`` is constrained to the gate's known actions so an invalid
 * value is rejected with 422 instead of being silently mis-routed by
 * ``route_approval`` (anything other than approve/reject is treated as an
 * edit re-validation).
 */
export const zApproveImportIn = z.object({
    decision: z.enum([
        'approve',
        'reject',
        'edit'
    ]),
    rules: z.optional(z.union([
        z.unknown(),
        z.null()
    ]))
});

/**
 * ImportRowErrorOut
 *
 * Single per-row import error.
 *
 * Legacy rows (``{row, error}``) deserialize fine because all
 * enriched fields default to ``None``. New rows produced by
 * ``RowError.to_dict()`` populate every field.
 */
export const zImportRowErrorOut = z.object({
    row: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    level: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    column: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    value: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    code: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    reason: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    suggested_fix: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    error: z.string()
});

/**
 * MappingOut
 *
 * Mapping applied (or available) for a run.
 */
export const zMappingOut = z.object({
    id: z.uuid(),
    strategy: z.string(),
    version: z.int(),
    rules: z.unknown(),
    origin: z.string(),
    is_active: z.boolean(),
    created_at: z.iso.datetime()
});

/**
 * SchemaOut
 *
 * Discovered file schema with inferred column metadata.
 */
export const zSchemaOut = z.object({
    id: z.uuid(),
    fingerprint: z.string(),
    data_type: z.string(),
    raw_columns: z.array(z.string()),
    inferred_columns: z.unknown(),
    sample_rows: z.unknown(),
    is_valid: z.boolean(),
    created_at: z.iso.datetime()
});

/**
 * TestResultOut
 *
 * Dry-run feedback: the sample-test outcome of the proposed mapping.
 *
 * Shown to the reviewer at ``PENDING_APPROVAL``. Distinct from the run's
 * ``records_*`` counters, which carry the real import. ``sample_size`` is
 * the number of sample rows the mapping processed in the dry run.
 */
export const zTestResultOut = z.object({
    sample_size: z.int(),
    created: z.int(),
    updated: z.int(),
    skipped: z.int(),
    errors_count: z.int(),
    row_errors: z.array(zImportRowErrorOut)
});

/**
 * ImportRunDetailOut
 *
 * Detail response — run with nested schema, mapping, and dry-run test.
 */
export const zImportRunDetailOut = z.object({
    id: z.uuid(),
    status: z.string(),
    data_type: z.optional(z.string()).default(''),
    file_name: z.optional(z.string()).default(''),
    source_rows: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    records_total: z.union([
        z.int(),
        z.null()
    ]),
    records_processed: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    records_created: z.union([
        z.int(),
        z.null()
    ]),
    records_updated: z.union([
        z.int(),
        z.null()
    ]),
    records_skipped: z.union([
        z.int(),
        z.null()
    ]),
    records_errored: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    errors_truncated: z.optional(z.boolean()).default(false),
    error_summary: z.unknown(),
    started_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    completed_at: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    source: zSourceOut,
    name: z.optional(z.string()).default(''),
    delivery_method: z.optional(z.string()).default(''),
    schedule: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    is_active: z.optional(z.boolean()).default(true),
    source_type: z.optional(z.string()).default(''),
    adapter_class: z.optional(z.string()).default(''),
    filename: z.optional(z.string()).default(''),
    file_hash: z.optional(z.string()).default(''),
    row_count: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    error_message: z.optional(z.string()).default(''),
    rows_processed: z.optional(z.int()).default(0),
    rows_failed: z.optional(z.int()).default(0),
    rows_skipped: z.optional(z.int()).default(0),
    exceptions_json: z.optional(z.unknown()),
    inferred_schema: z.optional(z.union([
        zSchemaOut,
        z.null()
    ])),
    mapping: z.optional(z.union([
        zMappingOut,
        z.null()
    ])),
    test_result: z.optional(z.union([
        zTestResultOut,
        z.null()
    ]))
});

/**
 * PaginatedImportRowErrorResponse
 */
export const zPaginatedImportRowErrorResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zImportRowErrorOut)
});

/**
 * ConnectionStatsOut
 *
 * Aggregate connection statistics.
 */
export const zConnectionStatsOut = z.object({
    total: z.int(),
    active: z.int(),
    inactive: z.int(),
    last_sync: z.union([
        z.iso.datetime(),
        z.null()
    ])
});

/**
 * ConnectionOut
 *
 * Output schema for a data source connection.
 */
export const zConnectionOut = z.object({
    id: z.uuid(),
    data_source_type: z.string(),
    adapter_class_name: z.string(),
    delivery_mechanism: z.string(),
    sftp_host: z.string(),
    sftp_path: z.string(),
    s3_bucket: z.string(),
    api_endpoint: z.string(),
    ingestion_frequency: z.string(),
    last_successful_ingest: z.union([
        z.iso.datetime(),
        z.null()
    ]),
    is_active: z.boolean(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * PaginatedConnectionResponse
 *
 * Paginated list of connections.
 */
export const zPaginatedConnectionResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zConnectionOut)
});

/**
 * ConnectionIn
 *
 * Input schema for creating a data source connection.
 */
export const zConnectionIn = z.object({
    data_source_type: z.string(),
    adapter_class_name: z.optional(z.string()).default(''),
    delivery_mechanism: z.string(),
    ingestion_frequency: z.string(),
    sftp_host: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    sftp_path: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    s3_bucket: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    api_endpoint: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    is_active: z.optional(z.boolean()).default(true)
});

/**
 * ConnectionPatch
 *
 * Input schema for partially updating a connection.
 */
export const zConnectionPatch = z.object({
    data_source_type: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    adapter_class_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    delivery_mechanism: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    ingestion_frequency: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    sftp_host: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    sftp_path: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    s3_bucket: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    api_endpoint: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    is_active: z.optional(z.union([
        z.boolean(),
        z.null()
    ]))
});

/**
 * ConnectionTestOut
 *
 * Result of a connection test or sync.
 */
export const zConnectionTestOut = z.object({
    status: z.string(),
    message: z.string()
});

/**
 * CycleSummary
 */
export const zCycleSummary = z.object({
    cycle_name: z.string(),
    week_number: z.union([
        z.int(),
        z.null()
    ]),
    start_date: z.iso.date(),
    end_date: z.iso.date()
});

/**
 * KPISummary
 */
export const zKpiSummary = z.object({
    active_work_orders: z.int(),
    avg_compliance: z.union([
        z.number(),
        z.null()
    ]),
    labor_actual_hours: z.number(),
    labor_estimated_hours: z.number(),
    stores_with_actual_hours: z.int(),
    stores_covered: z.int(),
    stores_total: z.int(),
    visits_completed: z.int(),
    visits_total: z.int(),
    estimated_cost: z.number(),
    actual_cost: z.union([
        z.number(),
        z.null()
    ])
});

/**
 * WorkOrderSummaryCount
 */
export const zWorkOrderSummaryCount = z.object({
    closed: z.int(),
    closed_expired: z.optional(z.int()).default(0),
    in_progress: z.int(),
    scheduled: z.int(),
    completed: z.optional(z.int()).default(0),
    unscheduled: z.optional(z.int()).default(0)
});

/**
 * WorkTypeCompletion
 */
export const zWorkTypeCompletion = z.object({
    total: z.int(),
    completed: z.int()
});

/**
 * TaskCompletionSummary
 */
export const zTaskCompletionSummary = z.object({
    reset: zWorkTypeCompletion,
    nici: zWorkTypeCompletion
});

/**
 * MissionControlSummaryOut
 */
export const zMissionControlSummaryOut = z.object({
    cycle: z.union([
        zCycleSummary,
        z.null()
    ]),
    kpis: zKpiSummary,
    work_order_summary: zWorkOrderSummaryCount,
    task_completion: zTaskCompletionSummary
});

/**
 * CategoryComplianceOut
 */
export const zCategoryComplianceOut = z.object({
    category_id: z.union([
        z.uuid(),
        z.null()
    ]),
    compliance: z.union([
        z.number(),
        z.null()
    ]),
    osa: z.union([
        z.number(),
        z.null()
    ])
});

/**
 * WorkOrderListOut
 */
export const zWorkOrderListOut = z.object({
    id: z.uuid(),
    project_id: z.uuid(),
    project_name: z.string(),
    store_id: z.uuid(),
    store_name: z.string(),
    store_address: z.string(),
    store_region_id: z.union([
        z.uuid(),
        z.null()
    ]),
    store_region_name: z.optional(z.string()).default(''),
    store_timezone: z.optional(z.string()).default(''),
    assigned_employee_id: z.union([
        z.uuid(),
        z.null()
    ]),
    assigned_employee_name: z.union([
        z.string(),
        z.null()
    ]),
    status: z.string(),
    closed_reason: z.optional(z.string()).default(''),
    lifecycle_status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    execution_outcome: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    execution_status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    active_sessions: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    estimated_hours: z.union([
        z.number(),
        z.null()
    ]),
    actual_hours: z.union([
        z.number(),
        z.null()
    ]),
    estimated_cost: z.union([
        z.number(),
        z.null()
    ]),
    actual_cost: z.union([
        z.number(),
        z.null()
    ]),
    scheduled_range: z.union([
        z.array(z.iso.date()),
        z.null()
    ]),
    work_item_types: z.array(z.string()),
    created_at: z.iso.datetime(),
    work_items_total: z.optional(z.int()).default(0),
    work_items_completed: z.optional(z.int()).default(0),
    work_items_partially_completed: z.optional(z.int()).default(0),
    last_captured_at: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    compliance: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    osa: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    category_compliance: z.optional(z.array(zCategoryComplianceOut)).default([]),
    assigned_team_lead_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    assigned_team_lead_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    scheduled_start_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ]))
});

/**
 * PaginatedWorkOrderResponse
 */
export const zPaginatedWorkOrderResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zWorkOrderListOut)
});

/**
 * AlertOut
 */
export const zAlertOut = z.object({
    id: z.string(),
    type: z.string(),
    title: z.string(),
    message: z.string(),
    timestamp: z.iso.datetime()
});

/**
 * EscalationOut
 */
export const zEscalationOut = z.object({
    id: z.uuid(),
    work_order_id: z.uuid(),
    store_name: z.string(),
    assigned_employee_name: z.union([
        z.string(),
        z.null()
    ]),
    exception_type_name: z.string(),
    exception_type_id: z.string(),
    severity: z.string(),
    description: z.string(),
    resolution_status: z.string(),
    created_at: z.iso.datetime(),
    assigned_team_lead_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    exception_severity: z.optional(z.string()).default(''),
    metadata: z.optional(z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])),
    discovered_by: z.optional(z.string()).default(''),
    resolution_type: z.optional(z.string()).default(''),
    resolution_notes: z.optional(z.string()).default('')
});

/**
 * PaginatedEscalationResponse
 */
export const zPaginatedEscalationResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zEscalationOut)
});

/**
 * EscalationActionIn
 */
export const zEscalationActionIn = z.object({
    action: z.string(),
    notes: z.optional(z.string()).default('')
});

/**
 * NiciTrackingSummaryOut
 *
 * Project-level totals behind the Mission Control NICI screens.
 *
 * A store is one work order, so a project spanning several cycles
 * counts a store once per cycle unless the request pins one.
 */
export const zNiciTrackingSummaryOut = z.object({
    total_stores: z.int(),
    stores_submitted: z.int(),
    total_item_stores: z.int(),
    on_shelf: z.int(),
    not_on_shelf: z.int(),
    to_do: z.int(),
    on_shelf_percent: z.int(),
    rollover_item_stores: z.int(),
    unique_items: z.int()
});

/**
 * NiciTrackingStoreRowOut
 *
 * One store's NICI task, as the Stores table lists it.
 *
 * Keyed on the work order rather than the store: the same store works
 * the same project again next cycle, and the two runs are different
 * rows with different results.
 *
 * ``on_shelf``, ``not_on_shelf`` and ``to_do`` partition
 * ``total_items``, so the column the design calls "Remaining" is
 * whichever of the last two the task status makes meaningful.
 */
export const zNiciTrackingStoreRowOut = z.object({
    execution_status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    lifecycle_status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    execution_outcome: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    has_active_attempt: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    remaining_items: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    work_order_id: z.uuid(),
    store_id: z.uuid(),
    store_name: z.optional(z.string()).default(''),
    store_address: z.optional(z.string()).default(''),
    store_region_name: z.optional(z.string()).default(''),
    task_status: z.optional(z.string()).default(''),
    total_items: z.optional(z.int()).default(0),
    on_shelf: z.optional(z.int()).default(0),
    not_on_shelf: z.optional(z.int()).default(0),
    to_do: z.optional(z.int()).default(0),
    on_shelf_percent: z.optional(z.int()).default(0),
    categories: z.optional(z.int()).default(0),
    rollover_items: z.optional(z.int()).default(0),
    last_submission: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ]))
});

/**
 * PaginatedNiciTrackingStoreResponse
 */
export const zPaginatedNiciTrackingStoreResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zNiciTrackingStoreRowOut)
});

/**
 * NiciTrackingItemRowOut
 *
 * One product across every store the project assigns it to.
 */
export const zNiciTrackingItemRowOut = z.object({
    product_id: z.uuid(),
    name: z.optional(z.string()).default(''),
    upc: z.optional(z.string()).default(''),
    category_name: z.optional(z.string()).default(''),
    stores_assigned: z.optional(z.int()).default(0),
    on_shelf: z.optional(z.int()).default(0),
    not_on_shelf: z.optional(z.int()).default(0),
    to_do: z.optional(z.int()).default(0),
    on_shelf_percent: z.optional(z.int()).default(0),
    rollover_stores: z.optional(z.int()).default(0)
});

/**
 * PaginatedNiciTrackingItemResponse
 */
export const zPaginatedNiciTrackingItemResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zNiciTrackingItemRowOut)
});

/**
 * NiciTrackingRolloutStoreOut
 *
 * One store's attempt at a single cut-in.
 */
export const zNiciTrackingRolloutStoreOut = z.object({
    execution_status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    lifecycle_status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    execution_outcome: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    has_active_attempt: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    remaining_items: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    work_order_id: z.uuid(),
    store_id: z.uuid(),
    store_name: z.optional(z.string()).default(''),
    task_status: z.optional(z.string()).default(''),
    item_status: z.optional(z.string()).default(''),
    rollover_count: z.optional(z.int()).default(0),
    rollover_reason: z.optional(z.string()).default(''),
    distribution_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    cut_in_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    last_submission: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ]))
});

/**
 * PaginatedNiciTrackingRolloutResponse
 *
 * The product's own totals beside the stores it went to.
 *
 * Header-plus-results, the shape ``PaginatedWorkItemResponse`` already
 * uses: the totals describe every store, not the page.
 */
export const zPaginatedNiciTrackingRolloutResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zNiciTrackingRolloutStoreOut),
    summary: zNiciTrackingItemRowOut
});

/**
 * FieldworkAssignedStoreOut
 *
 * One employee assignment grouped at the visit and store level.
 */
export const zFieldworkAssignedStoreOut = z.object({
    visit_id: z.uuid(),
    visit_status: z.string(),
    visit_assignment_id: z.uuid(),
    visit_assignment_employee_id: z.uuid(),
    visit_assignment_status: z.string(),
    store_id: z.uuid(),
    store_name: z.string(),
    store_address: z.string(),
    store_latitude: z.union([
        z.number(),
        z.null()
    ]),
    store_longitude: z.union([
        z.number(),
        z.null()
    ]),
    store_geofence_radius_m: z.int(),
    work_item_types: z.array(z.string()),
    estimated_hours: z.union([
        z.number(),
        z.null()
    ]),
    planned_date: z.iso.date()
});

/**
 * PaginatedFieldworkAssignedStoreResponse
 */
export const zPaginatedFieldworkAssignedStoreResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zFieldworkAssignedStoreOut)
});

/**
 * FieldworkVisitWorkOrderOut
 */
export const zFieldworkVisitWorkOrderOut = z.object({
    id: z.uuid(),
    status: z.string()
});

/**
 * FieldworkVisitOut
 */
export const zFieldworkVisitOut = z.object({
    id: z.uuid(),
    status: z.string(),
    planned_date: z.iso.date(),
    notes: z.string(),
    manager_name: z.string(),
    manager_rating: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    manager_comment: z.string(),
    manager_signed_at: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    completed_at: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    signature_captured: z.boolean(),
    work_order_ids: z.array(z.uuid()),
    work_orders: z.array(zFieldworkVisitWorkOrderOut)
});

/**
 * SignOffBlockerOut
 */
export const zSignOffBlockerOut = z.object({
    code: z.string(),
    work_order_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    work_item_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    work_item_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    title: z.string(),
    message: z.string()
});

/**
 * SignOffConflictOut
 */
export const zSignOffConflictOut = z.object({
    can_sign_off: z.optional(z.boolean()).default(false),
    blocker: zSignOffBlockerOut
});

/**
 * FieldworkVisitUpdateIn
 */
export const zFieldworkVisitUpdateIn = z.object({
    status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    planned_date: z.optional(z.union([
        z.iso.date(),
        z.null()
    ])),
    notes: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    manager_name: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    manager_rating: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    manager_comment: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * FieldworkEmployeeOut
 *
 * The person an assignment belongs to.
 *
 * Name parts stay split so the client picks its own formatting.
 * ``user_id`` is the linked auth user and is ``None`` for an employee
 * with no account yet (``Employee.user`` is nullable).
 */
export const zFieldworkEmployeeOut = z.object({
    id: z.uuid(),
    first_name: z.string(),
    last_name: z.string(),
    contact_email: z.string(),
    user_id: z.union([
        z.uuid(),
        z.null()
    ])
});

/**
 * FieldworkStoreOut
 */
export const zFieldworkStoreOut = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string()
});

/**
 * FieldworkAssignmentOut
 *
 * Uniform representation for list, detail, and PATCH responses.
 *
 * Two pairs of times, three concepts, and the same words the CSV
 * export uses:
 *
 * * ``checkin_at`` / ``checkout_at`` — the operative times: what the
 * worker stands behind after any correction, and what
 * ``labor_minutes`` is computed from. The plain name carries the
 * value a screen should show, so a client that reads no further is
 * right by default.
 * * ``system_checkin_at`` / ``system_checkout_at`` — the fact the
 * server stamped at the geofence, never rewritten. Evidence, not a
 * claim; show it in history or audit.
 * * ``is_adjusted`` — whether either end was moved, which is the same
 * as whether the two pairs differ.
 *
 * Note that ``checkin_at`` here is deliberately *not* the model column
 * of that name: the column holds the stamped fact, and the wire name
 * belongs to the value clients act on. The resolvers below say which
 * is which.
 */
export const zFieldworkAssignmentOut = z.object({
    id: z.uuid(),
    status: z.string(),
    checkin_at: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    checkout_at: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    system_checkin_at: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    system_checkout_at: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    is_adjusted: z.optional(z.boolean()).default(false),
    labor_minutes: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    checkout_action: z.optional(z.union([
        z.enum(['CHECK_OUT', 'SIGN_OFF']),
        z.null()
    ])),
    employee: zFieldworkEmployeeOut,
    store: zFieldworkStoreOut,
    visit: zFieldworkVisitOut
});

/**
 * PaginatedFieldworkAssignmentResponse
 */
export const zPaginatedFieldworkAssignmentResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zFieldworkAssignmentOut)
});

/**
 * FieldworkAssignmentUpdateIn
 *
 * Requested status transition, plus the geolocation proving it.
 *
 * ``status`` is the target the client asks for, not a hint: the
 * server never infers the transition from the current state. The
 * supported targets are ``CHECKED_IN`` and ``CHECKED_OUT``; the
 * geolocation is enforced on check-in and audited (but never
 * enforced) on check-out.
 */
export const zFieldworkAssignmentUpdateIn = z.object({
    status: z.string(),
    lat: z.number(),
    lon: z.number(),
    accuracy_m: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    device_timestamp: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ]))
});

/**
 * PaginatedFieldworkWorkItemResponse
 */
export const zPaginatedFieldworkWorkItemResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zWorkItemOut)
});

/**
 * WorkdayTimesheetOut
 *
 * A worker's daily timesheet for list, detail, and PATCH responses.
 */
export const zWorkdayTimesheetOut = z.object({
    id: z.uuid(),
    employee: zFieldworkEmployeeOut,
    date: z.iso.date(),
    total_break_minutes: z.int(),
    calculated_labor_minutes: z.int(),
    travel_minutes: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    mileage_miles: z.optional(z.union([
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null()
    ])),
    status: z.string(),
    confirmed_at: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    break_answers: z.record(z.string(), z.unknown()),
    submitted_with_adjustments: z.boolean()
});

/**
 * PaginatedWorkdayTimesheetResponse
 */
export const zPaginatedWorkdayTimesheetResponse = z.object({
    count: z.int(),
    next: z.union([
        z.string(),
        z.null()
    ]),
    previous: z.union([
        z.string(),
        z.null()
    ]),
    results: z.array(zWorkdayTimesheetOut)
});

/**
 * ViolationTargetOut
 *
 * What a problem is attached to, so a client never has to guess.
 *
 * ``type`` alone decides where the message goes, which is why it is
 * published instead of leaving the client to map ``error_code`` to an
 * anchor: a code added later changes nothing in that mapping.
 */
export const zViolationTargetOut = z.object({
    type: z.string(),
    id: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * ViolationOut
 *
 * One problem with a submit — a visit time or a break answer.
 */
export const zViolationOut = z.object({
    error_code: z.string(),
    message: z.string(),
    target: zViolationTargetOut
});

/**
 * DaySubmitPreviewOut
 *
 * ``?dry_run=true`` result: what would happen, nothing written.
 *
 * ``id`` and ``dry_run`` make the body say what it is instead of
 * leaving a client to infer it from the query parameter it sent
 * itself. ``id`` also settles a race the screen will have: a preview
 * fires on every edit of an answer, and without it a late response
 * for the previous day is indistinguishable from the current one.
 * ``dry_run`` is typed as a constant because on this path it can only
 * be true — the real submit answers with the timesheet.
 */
export const zDaySubmitPreviewOut = z.object({
    id: z.uuid(),
    dry_run: z.literal(true),
    blocking: z.array(zViolationOut),
    warnings: z.array(zViolationOut),
    comment_required: z.boolean(),
    total_break_minutes: z.int(),
    calculated_labor_minutes: z.int()
});

/**
 * VisitTimeAdjustmentIn
 *
 * One visit correction. An omitted end is left as it is.
 *
 * ``visit_assignment_id`` and not ``assignment_id``: the entity is a
 * visit assignment everywhere else — in the path, in the violation
 * target — and "assignment" on its own is ambiguous in this product,
 * which also has training assignments and store assignments.
 */
export const zVisitTimeAdjustmentIn = z.object({
    visit_assignment_id: z.uuid(),
    checkin_at: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    checkout_at: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ]))
});

/**
 * WorkdayTimesheetUpdateIn
 *
 * End-of-day submit: corrections, break answers, and the transition.
 *
 * One request closes the whole day.
 */
export const zWorkdayTimesheetUpdateIn = z.object({
    status: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    policy_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    break_answers: z.optional(z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])),
    adjustment_note: z.optional(z.string()).default(''),
    adjustments: z.optional(z.array(zVisitTimeAdjustmentIn)).default([])
});

/**
 * FormQuestionOut
 *
 * One question, in the order the array already puts it in.
 *
 * The document's ``order`` is not published: it is what sorted this
 * list, and a client that re-sorted by it would be reproducing a
 * decision the server has already made.
 */
export const zFormQuestionOut = z.object({
    code: z.string(),
    label: z.string(),
    answer: z.record(z.string(), z.unknown()),
    required: z.boolean()
});

/**
 * BreakFormOut
 *
 * The server-owned break form for one day.
 */
export const zBreakFormOut = z.object({
    policy_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    schema_version: z.int(),
    gross_minutes: z.int(),
    questions: z.array(zFormQuestionOut)
});

/**
 * CreateChatOut
 */
export const zCreateChatOut = z.object({
    chat_id: z.uuid()
});

/**
 * ErrorOut
 */
export const zErrorOut = z.object({
    detail: z.string()
});

/**
 * CreateChatIn
 */
export const zCreateChatIn = z.object({
    store_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    work_order_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ])),
    work_item_id: z.optional(z.union([
        z.uuid(),
        z.null()
    ]))
});

/**
 * SendMessageIn
 */
export const zSendMessageIn = z.object({
    content: z.string()
});

export const zCoreHealthcheckApiHealthCheckData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zAccountsApiDiscoveryGetAuthenticationMethodsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zAccountsApiDiscoveryGetAuthenticationMethodsResponse = z.array(z.union([z.object({
        type: z.literal('otp')
    }).and(zOtpAuthenticationMethodOut), z.object({
        type: z.literal('sso')
    }).and(zSsoAuthenticationMethodOut)]));

export const zAccountsApiLegacyGoogleLoginData = z.object({
    body: zGoogleLoginIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zAccountsApiLegacyGoogleLoginResponse = zAuthResponse;

export const zAccountsApiLegacyLogoutData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zAccountsApiLegacyLogoutResponse = z.void();

export const zAccountsApiProfileGetCurrentUserData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zAccountsApiProfileGetCurrentUserResponse = zAuthResponse;

export const zAccountsApiOtpRequestData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Accepted
 */
export const zAccountsApiOtpRequestResponse = zOtpRequestOut;

export const zAccountsApiOtpVerifyData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zAccountsApiOtpVerifyResponse = zOtpVerifyOut;

export const zAccountsApiSessionsRefreshData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zAccountsApiSessionsRefreshResponse = zApplicationSessionRefreshOut;

export const zAccountsApiSessionsSessionLogoutData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zAccountsApiSessionsSessionLogoutResponse = z.void();

export const zAccountsApiSsoExchangeData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zAccountsApiSsoExchangeResponse = zSsoExchangeOut;

export const zProjectsApiProjectsListCyclesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        upcoming: z.optional(z.boolean()).default(true)
    }))
});

/**
 * Response
 *
 * OK
 */
export const zProjectsApiProjectsListCyclesResponse = z.array(zCycleOut);

export const zProjectsApiProjectsListProjectsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        project_type: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        cycle_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        region_id: z.optional(z.union([
            z.array(z.uuid()),
            z.null()
        ]))
    }))
});

/**
 * Response
 *
 * OK
 */
export const zProjectsApiProjectsListProjectsResponse = z.array(zProjectProgressOut);

export const zProjectsApiProjectsCreateProjectData = z.object({
    body: zProjectIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zProjectsApiProjectsCreateProjectResponse = zProjectOut;

export const zProjectsApiProjectsListWorkOrderWorkItemsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        work_order_id: z.uuid()
    }),
    query: z.optional(z.object({
        item_type: z.optional(z.union([
            zWorkItemType,
            z.null()
        ])),
        assigned_employee: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        task_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiProjectsListWorkOrderWorkItemsResponse = zPaginatedWorkItemResponse;

export const zProjectsApiProjectsUpdateWorkItemData = z.object({
    body: zWorkItemPatch,
    path: z.object({
        work_item_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiProjectsUpdateWorkItemResponse = zWorkItemOut;

export const zProjectsApiProjectsGetBackroomNewItemRequirementsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        work_item_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiProjectsGetBackroomNewItemRequirementsResponse = zBackroomNewItemRequirementsOut;

export const zProjectsApiProjectsApplyBackroomNewItemCollectionActionData = z.object({
    body: zBackroomNewItemCollectionActionIn,
    path: z.object({
        work_item_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiProjectsApplyBackroomNewItemCollectionActionResponse = zBackroomNewItemCollectionActionOut;

export const zProjectsApiProjectsCreateExceptionEventData = z.object({
    body: zExceptionEventIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zProjectsApiProjectsCreateExceptionEventResponse = zExceptionEventOut;

export const zProjectsApiProjectsListExceptionEventTypesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        is_active: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        group: z.optional(z.union([
            zExceptionEventTypeGroup,
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiProjectsListExceptionEventTypesResponse = zPaginatedExceptionEventTypeResponse;

export const zProjectsApiProjectsListFieldPhotosData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        visit_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        planogram_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        work_item_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        category_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        bay_number: z.optional(z.union([
            z.int(),
            z.null()
        ])),
        photo_type: z.optional(z.union([
            zPhotoType,
            z.null()
        ])),
        photo_phase: z.optional(z.union([
            zPhotoPhase,
            z.null()
        ])),
        edge_validation_passed: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        barcode: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        device_model: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        latest_batch: z.optional(z.boolean()).default(false),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiProjectsListFieldPhotosResponse = zPaginatedFieldPhotoResponse;

export const zProjectsApiProjectsCreateFieldPhotoData = z.object({
    body: z.object({
        image: z.string(),
        visit_id: z.uuid(),
        photo_type: z.enum([
            'SHELF_WIDE',
            'SECTION_DETAIL',
            'CLOSE_UP',
            'PRICE_TAG',
            'ENDCAP',
            'BACKROOM',
            'OTHER'
        ]),
        photo_phase: z.enum([
            'BEFORE',
            'AFTER',
            'PROOF'
        ]),
        work_item_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        captured_at_utc: z.optional(z.union([
            z.iso.datetime(),
            z.null()
        ])),
        captured_at: z.optional(z.union([
            z.iso.datetime(),
            z.null()
        ])),
        bay_number: z.optional(z.union([
            z.int(),
            z.null()
        ])),
        is_new_bay: z.optional(z.boolean()).default(false),
        category_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        planogram_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        barcode: z.optional(z.string()).default(''),
        device_model: z.optional(z.string()).default(''),
        edge_validation_passed: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        notes: z.optional(z.string()).default('')
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zProjectsApiProjectsCreateFieldPhotoResponse = zFieldPhotoOut;

export const zProjectsApiProjectsDeleteProjectData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zProjectsApiProjectsDeleteProjectResponse = z.void();

export const zProjectsApiProjectsGetProjectData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiProjectsGetProjectResponse = zProjectOut;

export const zProjectsApiProjectsUpdateProjectData = z.object({
    body: zProjectPatch,
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiProjectsUpdateProjectResponse = zProjectOut;

export const zProjectsApiProjectsTransitionProjectData = z.object({
    body: zTransitionIn,
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiProjectsTransitionProjectResponse = zProjectOut;

export const zProjectsApiWizardWizardInitData = z.object({
    body: zWizardInitIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zProjectsApiWizardWizardInitResponse = zWizardInitOut;

export const zProjectsApiWizardWizardSaveDraftData = z.object({
    body: zSaveDraftIn,
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'If-Match': z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zProjectsApiWizardWizardSaveDraftResponse = zSaveDraftOut;

export const zProjectsApiWizardWizardResumeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardResumeResponse = zResumeOut;

export const zProjectsApiWizardWizardOptionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardOptionsResponse = zWizardOptionsOut;

export const zProjectsApiWizardWizardProjectTypesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardProjectTypesResponse = zWizardProjectTypesOut;

export const zProjectsApiWizardWizardParseDescriptionData = z.object({
    body: zParseDescriptionIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardParseDescriptionResponse = zParseDescriptionOut;

export const zProjectsApiWizardWizardTranscribeData = z.object({
    body: z.object({
        audio: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardTranscribeResponse = zTranscribeOut;

export const zProjectsApiWizardWizardParseVoiceData = z.object({
    body: z.object({
        audio: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardParseVoiceResponse = zParseVoiceOut;

export const zProjectsApiWizardWizardAnalyzeV2Data = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardAnalyzeV2Response = zAnalyzeScopeV2Out;

export const zProjectsApiWizardWizardAnalyzeData = z.object({
    body: zAnalyzeScopeIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardAnalyzeResponse = zAnalyzeScopeOut;

export const zProjectsApiWizardWizardScheduleV2Data = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardScheduleV2Response = zScheduleV2Out;

export const zProjectsApiWizardWizardScheduleApplyData = z.object({
    body: zApplyScheduleOverridesIn,
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'If-Match': z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zProjectsApiWizardWizardScheduleApplyResponse = zScheduleV2Out;

export const zProjectsApiWizardWizardAssignTeamsV2Data = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardAssignTeamsV2Response = zAssignTeamsV2Out;

export const zProjectsApiWizardWizardCostEstimateData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardCostEstimateResponse = zCostEstimateOut;

export const zProjectsApiWizardWizardRefreshData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'If-Match': z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zProjectsApiWizardWizardRefreshResponse = zResumeOut;

export const zProjectsApiWizardWizardCreateData = z.object({
    body: zWizardCreateIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zProjectsApiWizardWizardCreateResponse = zWizardCreateOut;

export const zProjectsApiWizardWizardApproveData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiWizardWizardApproveResponse = zApproveOut;

export const zProjectsApiEditEditInitData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.object({
        force: z.optional(z.boolean()).default(false)
    }))
});

/**
 * Created
 */
export const zProjectsApiEditEditInitResponse = zEditInitOut;

export const zProjectsApiEditEditSaveDraftData = z.object({
    body: zEditSaveDraftIn,
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiEditEditSaveDraftResponse = zEditStateOut;

export const zProjectsApiEditEditResumeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiEditEditResumeResponse = zEditStateOut;

export const zProjectsApiEditEditCancelData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zProjectsApiEditEditCancelResponse = z.void();

export const zProjectsApiEditEditAnalyzeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiEditEditAnalyzeResponse = zEditAnalyzeOut;

export const zProjectsApiEditEditScheduleData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiEditEditScheduleResponse = zEditScheduleOut;

export const zProjectsApiEditEditAssignTeamsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiEditEditAssignTeamsResponse = zEditAssignTeamsOut;

export const zProjectsApiEditEditCostEstimateData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiEditEditCostEstimateResponse = zEditCostOut;

export const zProjectsApiEditEditCommitData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'If-Match': z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zProjectsApiEditEditCommitResponse = zEditCommitOut;

export const zProjectsApiNiciScansListNiciScansData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        work_order_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        task_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiNiciScansListNiciScansResponse = zPaginatedNiciScanResponse;

export const zProjectsApiTimeEntriesListTimeEntriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        visit_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        work_order_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        work_item_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        task_type: z.optional(z.union([
            zTaskType,
            z.null()
        ])),
        entry_type: z.optional(z.union([
            zTimeEntryType,
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiTimeEntriesListTimeEntriesResponse = zPaginatedTimeEntryResponse;

export const zProjectsApiNiciResolutionsCreateNiciResolutionData = z.object({
    body: zNiciResolutionIn,
    path: z.object({
        work_item_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiNiciResolutionsCreateNiciResolutionResponse = zNiciResolutionOut;

export const zCategoriesApiCategoryStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zCategoriesApiCategoryStatsResponse = zCategoryStatsOut;

export const zCategoriesApiListCategoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        level: z.optional(z.union([
            z.int(),
            z.null()
        ])),
        parent_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zCategoriesApiListCategoriesResponse = zPaginatedCategoryResponse;

export const zCategoriesApiCreateCategoryData = z.object({
    body: zCategoryIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zCategoriesApiCreateCategoryResponse = zCategoryOut;

export const zCategoriesApiDeleteCategoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        category_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zCategoriesApiDeleteCategoryResponse = z.void();

export const zCategoriesApiGetCategoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        category_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zCategoriesApiGetCategoryResponse = zCategoryOut;

export const zCategoriesApiUpdateCategoryData = z.object({
    body: zCategoryPatch,
    path: z.object({
        category_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zCategoriesApiUpdateCategoryResponse = zCategoryOut;

export const zStoresApiStoreStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        region: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        banner: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        segment: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zStoresApiStoreStatsResponse = zStoreStatsOut;

export const zStoresApiListSegmentsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        is_active: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        in_use: z.optional(z.union([
            z.boolean(),
            z.null()
        ]))
    }))
});

/**
 * Response
 *
 * OK
 */
export const zStoresApiListSegmentsResponse = z.array(zLookupOut);

export const zStoresApiListStoreTypesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        is_active: z.optional(z.union([
            z.boolean(),
            z.null()
        ]))
    }))
});

/**
 * Response
 *
 * OK
 */
export const zStoresApiListStoreTypesResponse = z.array(zLookupOut);

export const zStoresApiListStoreFormatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        is_active: z.optional(z.union([
            z.boolean(),
            z.null()
        ]))
    }))
});

/**
 * Response
 *
 * OK
 */
export const zStoresApiListStoreFormatsResponse = z.array(zLookupOut);

export const zStoresApiListRegionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zStoresApiListRegionsResponse = z.array(zRegionOut);

export const zStoresApiListBannersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zStoresApiListBannersResponse = z.array(zRegionOut);

export const zStoresApiListStoreGroupsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        search: z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }))
});

/**
 * Response
 *
 * OK
 */
export const zStoresApiListStoreGroupsResponse = z.array(zStoreGroupOut);

export const zStoresApiListStatesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zStoresApiListStatesResponse = z.array(z.string());

export const zStoresApiListStoresData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        segment: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        state: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        store_type: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        region: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        banner: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zStoresApiListStoresResponse = zPaginatedStoreResponse;

export const zStoresApiCreateStoreData = z.object({
    body: zStoreIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zStoresApiCreateStoreResponse = zStoreOut;

export const zStoresApiDeleteStoreData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        store_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zStoresApiDeleteStoreResponse = z.void();

export const zStoresApiGetStoreData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        store_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zStoresApiGetStoreResponse = zStoreOut;

export const zStoresApiUpdateStoreData = z.object({
    body: zStorePatch,
    path: z.object({
        store_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zStoresApiUpdateStoreResponse = zStoreOut;

export const zEmployeesApiEmployeeStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zEmployeesApiEmployeeStatsResponse = zEmployeeStatsOut;

export const zEmployeesApiListEmploymentTypesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zEmployeesApiListEmploymentTypesResponse = z.array(zEmploymentTypeOut);

export const zEmployeesApiListEmployeeRolesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zEmployeesApiListEmployeeRolesResponse = z.array(zEmployeeRoleOut);

export const zEmployeesApiListEmployeesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        role_title: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        role: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zEmployeesApiListEmployeesResponse = zPaginatedEmployeeResponse;

export const zEmployeesApiCreateEmployeeData = z.object({
    body: zEmployeeIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zEmployeesApiCreateEmployeeResponse = zEmployeeOut;

export const zEmployeesApiDeleteEmployeeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        employee_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zEmployeesApiDeleteEmployeeResponse = z.void();

export const zEmployeesApiGetEmployeeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        employee_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zEmployeesApiGetEmployeeResponse = zEmployeeOut;

export const zEmployeesApiUpdateEmployeeData = z.object({
    body: zEmployeePatch,
    path: z.object({
        employee_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zEmployeesApiUpdateEmployeeResponse = zEmployeeOut;

export const zMobileApiListWorkItemBaysData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        work_item_id: z.uuid()
    }),
    query: z.optional(z.object({
        photo_phase: z.optional(z.enum([
            'BEFORE',
            'AFTER',
            'PROOF'
        ])).default('BEFORE')
    }))
});

/**
 * Response
 *
 * OK
 */
export const zMobileApiListWorkItemBaysResponse = z.array(zWorkItemBayOut);

export const zMobileApiValidateWorkOrderLocationData = z.object({
    body: zVisitLocationAttemptIn,
    path: z.object({
        work_order_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zMobileApiValidateWorkOrderLocationResponse = zVisitLocationAttemptOut;

export const zMobileApiStartWorkOrderVisitData = z.object({
    body: z.optional(z.union([
        zStartVisitIn,
        z.null()
    ])),
    path: z.object({
        work_order_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMobileApiStartWorkOrderVisitResponse = zVisitStartOut;

export const zMobileApiStartWorkOrderNiciTaskData = z.object({
    body: z.optional(z.union([
        zNiciTaskTimingIn,
        z.null()
    ])),
    path: z.object({
        work_order_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMobileApiStartWorkOrderNiciTaskResponse = zNiciTaskStartOut;

export const zMobileApiSubmitWorkOrderNiciScanData = z.object({
    body: zNiciScanIn,
    path: z.object({
        work_order_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMobileApiSubmitWorkOrderNiciScanResponse = zNiciScanOut;

export const zMobileApiStopWorkOrderNiciTaskData = z.object({
    body: z.optional(z.union([
        zNiciTaskTimingIn,
        z.null()
    ])),
    path: z.object({
        work_order_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMobileApiStopWorkOrderNiciTaskResponse = zNiciTaskStopOut;

export const zMobileApiStartWorkItemTaskData = z.object({
    body: z.optional(z.union([
        zWorkItemStartIn,
        z.null()
    ])),
    path: z.object({
        work_item_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zMobileApiStartWorkItemTaskResponse = zWorkItemStartOut;

export const zMobileApiGetCompletionSummaryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        work_item_id: z.uuid()
    }),
    query: z.optional(z.object({
        visit_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zMobileApiGetCompletionSummaryResponse = zCompletionSummaryOut;

export const zMobileApiCompleteWorkItemTaskData = z.object({
    body: z.optional(z.union([
        zWorkItemCompleteIn,
        z.null()
    ])),
    path: z.object({
        work_item_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMobileApiCompleteWorkItemTaskResponse = zWorkItemCompleteOut;

export const zProductsProductsApiProductStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        category_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        brand_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zProductsProductsApiProductStatsResponse = zProductStatsOut;

export const zProductsProductsApiListBrandsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zProductsProductsApiListBrandsResponse = z.array(zProductBrandOut);

export const zProductsProductsApiListProductsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        category_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        brand_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProductsProductsApiListProductsResponse = zPaginatedProductResponse;

export const zProductsProductsApiCreateProductData = z.object({
    body: zProductIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zProductsProductsApiCreateProductResponse = zProductOut;

export const zProductsProductsApiDeleteProductData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        product_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zProductsProductsApiDeleteProductResponse = z.void();

export const zProductsProductsApiGetProductData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        product_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProductsProductsApiGetProductResponse = zProductOut;

export const zProductsProductsApiUpdateProductData = z.object({
    body: zProductPatch,
    path: z.object({
        product_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProductsProductsApiUpdateProductResponse = zProductOut;

export const zProductsProductsApiUploadProductImageData = z.object({
    body: z.object({
        file: z.string()
    }),
    path: z.object({
        product_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zProductsProductsApiUploadProductImageResponse = zProductImageOut;

export const zProductsProductsApiDeleteProductImageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        image_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zProductsProductsApiDeleteProductImageResponse = z.void();

export const zProductsProductsApiSetPrimaryProductImageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        image_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProductsProductsApiSetPrimaryProductImageResponse = zProductImageOut;

export const zPlanogramsApiPlanogramsPlanogramStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanogramsApiPlanogramsPlanogramStatsResponse = zPlanogramStatsOut;

export const zPlanogramsApiPlanogramsListPlanogramsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        segment: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        category: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        created_by: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        created_from: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        created_to: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        ordering: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zPlanogramsApiPlanogramsListPlanogramsResponse = zPaginatedPlanogramResponse;

export const zPlanogramsApiPlanogramsCreatePlanogramData = z.object({
    body: zPlanogramIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zPlanogramsApiPlanogramsCreatePlanogramResponse = zPlanogramOut;

export const zPlanogramsApiPlanogramsDeletePlanogramData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        planogram_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zPlanogramsApiPlanogramsDeletePlanogramResponse = z.void();

export const zPlanogramsApiPlanogramsGetPlanogramData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        planogram_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanogramsApiPlanogramsGetPlanogramResponse = zPlanogramOut;

export const zPlanogramsApiPlanogramsUpdatePlanogramData = z.object({
    body: zPlanogramPatch,
    path: z.object({
        planogram_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanogramsApiPlanogramsUpdatePlanogramResponse = zPlanogramOut;

export const zPlanogramsApiPlanogramsGetPlanogramDetailsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        planogram_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanogramsApiPlanogramsGetPlanogramDetailsResponse = zPlanogramDetailOut;

export const zPlanogramsApiPositionsListPlanogramPositionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        bay: z.uuid(),
        shelf: z.optional(z.union([
            z.int(),
            z.null()
        ]))
    })
});

/**
 * Response
 *
 * OK
 */
export const zPlanogramsApiPositionsListPlanogramPositionsResponse = z.array(zPlanogramPositionOut);

export const zPlanogramsApiVersionsListVersionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        category_id: z.uuid(),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    })
});

/**
 * OK
 */
export const zPlanogramsApiVersionsListVersionsResponse = zPaginatedPlanogramVersionResponse;

export const zPlanogramsApiVersionsPublishData = z.object({
    body: zPublishVersionIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zPlanogramsApiVersionsPublishResponse = zPlanogramVersionDetailOut;

export const zPlanogramsApiVersionsStoreReachData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        category_id: z.uuid()
    })
});

/**
 * OK
 */
export const zPlanogramsApiVersionsStoreReachResponse = zStoreReachOut;

export const zPlanogramsApiVersionsGetVersionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        version_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanogramsApiVersionsGetVersionResponse = zPlanogramVersionDetailOut;

export const zPlanogramsApiVisualizationGetVisualizationData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        bay: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        planogram: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        store: z.optional(z.union([
            z.uuid(),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zPlanogramsApiVisualizationGetVisualizationResponse = zPlanogramVisualizationOut;

export const zRulesApiRuleStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zRulesApiRuleStatsResponse = zPolicyRuleStatsOut;

export const zRulesApiListRulesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        rule_type: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        category: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        scope_type: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        is_active: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zRulesApiListRulesResponse = zPaginatedPolicyRuleResponse;

export const zRulesApiCreateRuleData = z.object({
    body: zPolicyRuleIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zRulesApiCreateRuleResponse = zPolicyRuleOut;

export const zRulesApiDeleteRuleData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        rule_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zRulesApiDeleteRuleResponse = z.void();

export const zRulesApiGetRuleData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        rule_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zRulesApiGetRuleResponse = zPolicyRuleOut;

export const zRulesApiUpdateRuleData = z.object({
    body: zPolicyRulePatch,
    path: z.object({
        rule_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zRulesApiUpdateRuleResponse = zPolicyRuleOut;

export const zSuppliersApiListSuppliersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zSuppliersApiListSuppliersResponse = z.array(zSupplierOut);

export const zMappingsApiStoreCategoriesStoreCategoryStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiStoreCategoriesStoreCategoryStatsResponse = zStoreCategoryStatsOut;

export const zMappingsApiStoreCategoriesListStoreCategoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        is_active: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        store_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        category_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zMappingsApiStoreCategoriesListStoreCategoriesResponse = zPaginatedStoreCategoryResponse;

export const zMappingsApiStoreCategoriesCreateStoreCategoryData = z.object({
    body: zStoreCategoryIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zMappingsApiStoreCategoriesCreateStoreCategoryResponse = zStoreCategoryOut;

export const zMappingsApiStoreCategoriesDeleteStoreCategoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        mapping_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zMappingsApiStoreCategoriesDeleteStoreCategoryResponse = z.void();

export const zMappingsApiStoreCategoriesGetStoreCategoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        mapping_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiStoreCategoriesGetStoreCategoryResponse = zStoreCategoryOut;

export const zMappingsApiStoreCategoriesUpdateStoreCategoryData = z.object({
    body: zStoreCategoryPatch,
    path: z.object({
        mapping_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiStoreCategoriesUpdateStoreCategoryResponse = zStoreCategoryOut;

export const zMappingsApiStorePlanogramsStorePlanogramStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiStorePlanogramsStorePlanogramStatsResponse = zStorePlanogramStatsOut;

export const zMappingsApiStorePlanogramsStorePlanogramGroupStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiStorePlanogramsStorePlanogramGroupStatsResponse = zStorePlanogramGroupStatsOut;

export const zMappingsApiStorePlanogramsListStorePlanogramGroupsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        store_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        category_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        planogram_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zMappingsApiStorePlanogramsListStorePlanogramGroupsResponse = zPaginatedStorePlanogramGroupResponse;

export const zMappingsApiStorePlanogramsListStorePlanogramsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        active_only: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        store_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        category_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        planogram_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        missing_location: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        exclude_expired: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zMappingsApiStorePlanogramsListStorePlanogramsResponse = zPaginatedStorePlanogramResponse;

export const zMappingsApiStorePlanogramsCreateStorePlanogramData = z.object({
    body: zStorePlanogramIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zMappingsApiStorePlanogramsCreateStorePlanogramResponse = zStorePlanogramOut;

export const zMappingsApiStorePlanogramsDeleteStorePlanogramData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        mapping_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zMappingsApiStorePlanogramsDeleteStorePlanogramResponse = z.void();

export const zMappingsApiStorePlanogramsGetStorePlanogramData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        mapping_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiStorePlanogramsGetStorePlanogramResponse = zStorePlanogramOut;

export const zMappingsApiStorePlanogramsUpdateStorePlanogramData = z.object({
    body: zStorePlanogramPatch,
    path: z.object({
        mapping_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiStorePlanogramsUpdateStorePlanogramResponse = zStorePlanogramOut;

export const zMappingsApiStoreProductsStoreProductStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiStoreProductsStoreProductStatsResponse = zStoreProductStatsOut;

export const zMappingsApiStoreProductsListStoreProductsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        item_status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        store_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        product_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zMappingsApiStoreProductsListStoreProductsResponse = zPaginatedStoreProductResponse;

export const zMappingsApiStoreProductsCreateStoreProductData = z.object({
    body: zStoreProductIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zMappingsApiStoreProductsCreateStoreProductResponse = zStoreProductOut;

export const zMappingsApiStoreProductsDeleteStoreProductData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        record_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zMappingsApiStoreProductsDeleteStoreProductResponse = z.void();

export const zMappingsApiStoreProductsGetStoreProductData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        record_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiStoreProductsGetStoreProductResponse = zStoreProductOut;

export const zMappingsApiStoreProductsUpdateStoreProductData = z.object({
    body: zStoreProductPatch,
    path: z.object({
        record_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiStoreProductsUpdateStoreProductResponse = zStoreProductOut;

export const zMappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        store_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        employee_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        is_primary: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        assignment_type: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        date_from: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        date_to: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        ordering: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zMappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsResponse = zPaginatedEmployeeStoreAssignmentResponse;

export const zMappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentData = z.object({
    body: zEmployeeStoreAssignmentIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zMappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentResponse = zEmployeeStoreAssignmentOut;

export const zMappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        store_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        employee_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        is_primary: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        assignment_type: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        date_from: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        date_to: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        search: z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zMappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsResponse = zEmployeeStoreAssignmentStatsOut;

export const zMappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        assignment_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentResponse = zEmployeeStoreAssignmentOut;

export const zMappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentData = z.object({
    body: zEmployeeStoreAssignmentPatch,
    path: z.object({
        assignment_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentResponse = zEmployeeStoreAssignmentOut;

export const zMappingsApiWorkingGroupsListWorkingGroupsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        status: z.optional(z.union([
            zWorkingGroupStatus,
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zMappingsApiWorkingGroupsListWorkingGroupsResponse = zPaginatedWorkingGroupResponse;

export const zMappingsApiWorkingGroupsCreateWorkingGroupData = z.object({
    body: zWorkingGroupIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zMappingsApiWorkingGroupsCreateWorkingGroupResponse = zWorkingGroupOut;

export const zMappingsApiWorkingGroupsWorkingGroupStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiWorkingGroupsWorkingGroupStatsResponse = zWorkingGroupStatsOut;

export const zMappingsApiWorkingGroupsGetWorkingGroupData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        group_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiWorkingGroupsGetWorkingGroupResponse = zWorkingGroupOut;

export const zMappingsApiWorkingGroupsUpdateWorkingGroupData = z.object({
    body: zWorkingGroupPatch,
    path: z.object({
        group_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zMappingsApiWorkingGroupsUpdateWorkingGroupResponse = zWorkingGroupOut;

export const zPlanningApiResetCalendarResetCycleStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanningApiResetCalendarResetCycleStatsResponse = zCycleStatsOut;

export const zPlanningApiResetCalendarListResetCyclesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zPlanningApiResetCalendarListResetCyclesResponse = zPaginatedCycleResponse;

export const zPlanningApiResetCalendarCreateResetCycleData = z.object({
    body: zCycleIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zPlanningApiResetCalendarCreateResetCycleResponse = zCycleOut;

export const zPlanningApiResetCalendarDeleteResetCycleData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        cycle_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zPlanningApiResetCalendarDeleteResetCycleResponse = z.void();

export const zPlanningApiResetCalendarGetResetCycleData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        cycle_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanningApiResetCalendarGetResetCycleResponse = zCycleOut;

export const zPlanningApiResetCalendarUpdateResetCycleData = z.object({
    body: zCyclePatch,
    path: z.object({
        cycle_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanningApiResetCalendarUpdateResetCycleResponse = zCycleOut;

export const zPlanningApiNiciNiciStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanningApiNiciNiciStatsResponse = zNiciStatsOut;

export const zPlanningApiNiciListNiciData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        ordering: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zPlanningApiNiciListNiciResponse = zPaginatedNiciResponse;

export const zPlanningApiNiciCreateNiciData = z.object({
    body: zNiciIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanningApiNiciCreateNiciResponse = zNiciBulkResult;

export const zPlanningApiNiciDeleteNiciData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nici_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zPlanningApiNiciDeleteNiciResponse = z.void();

export const zPlanningApiNiciGetNiciData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nici_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanningApiNiciGetNiciResponse = zNiciOut;

export const zPlanningApiNiciUpdateNiciData = z.object({
    body: zNiciPatch,
    path: z.object({
        nici_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zPlanningApiNiciUpdateNiciResponse = zNiciOut;

export const zStorageApiRequestUploadData = z.object({
    body: zRequestUploadIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zStorageApiRequestUploadResponse = zRequestUploadOut;

export const zStorageApiLocalFsUploadData = z.object({
    body: z.object({
        path: z.string(),
        checksum: z.string(),
        file_size: z.int(),
        file: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zStorageApiLocalFsUploadResponse = z.void();

export const zComplianceApiGetActionItemsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zComplianceApiGetActionItemsResponse = z.record(z.string(), z.unknown());

export const zComplianceApiListProductActionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        work_item_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        work_order_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        action_type: z.optional(z.union([
            z.array(zComplianceProductActionType),
            z.null()
        ])),
        bay_id: z.optional(z.union([
            z.array(z.uuid()),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zComplianceApiListProductActionsResponse = zPaginatedProductActionsOut;

export const zComplianceApiGetProductActionsPostResetPhotoStateData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        work_item_id: z.uuid()
    })
});

/**
 * OK
 */
export const zComplianceApiGetProductActionsPostResetPhotoStateResponse = zProductActionsPostResetPhotoStateOut;

export const zComplianceApiUpdateProductActionData = z.object({
    body: zProductActionPatchIn,
    path: z.object({
        product_action_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zComplianceApiUpdateProductActionResponse = zProductActionMutationOut;

export const zComplianceApiCompleteProductActionData = z.object({
    body: z.optional(z.union([
        zProductActionCompleteIn,
        z.null()
    ])),
    path: z.object({
        product_action_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zComplianceApiCompleteProductActionResponse = zProductActionMutationOut;

export const zComplianceApiBulkCompleteProductActionsData = z.object({
    body: zBulkProductActionCompleteIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zComplianceApiBulkCompleteProductActionsResponse = zBulkProductActionMutationOut;

export const zComplianceApiListPogCategoryRatesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zComplianceApiListPogCategoryRatesResponse = z.array(zPogCategoryRateOut);

export const zComplianceApiGetPogCategoryRateData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        category_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zComplianceApiGetPogCategoryRateResponse = zPogCategoryRateDetailOut;

export const zComplianceApiListPogStoreRatesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        planogram_id: z.uuid()
    })
});

/**
 * Response
 *
 * OK
 */
export const zComplianceApiListPogStoreRatesResponse = z.array(zPogStoreRateOut);

export const zIngestionApiImportsListImportsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        is_active: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zIngestionApiImportsListImportsResponse = zPaginatedImportRunResponse;

export const zIngestionApiImportsCreateImportData = z.object({
    body: z.object({
        file: z.string(),
        name: z.optional(z.string()).default('')
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zIngestionApiImportsCreateImportResponse = zImportRunCreateOut;

export const zIngestionApiImportsApproveImportData = z.object({
    body: zApproveImportIn,
    path: z.object({
        import_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * Accepted
 */
export const zIngestionApiImportsApproveImportResponse = z.record(z.string(), z.unknown());

export const zIngestionApiImportsImportsEventsStreamData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Server-Sent Events stream.
 *
 * Wire format per message:
 * ```
 * event: <type>
 * data: <json>
 *
 * ```
 *
 * A `:keepalive` comment is sent every 30 s.
 */
export const zIngestionApiImportsImportsEventsStreamResponse = z.union([
    z.object({
        active_imports: z.array(z.object({
            import_id: z.string(),
            status: z.string(),
            file_name: z.string(),
            source_rows: z.union([
                z.int(),
                z.null()
            ]),
            records_total: z.union([
                z.int(),
                z.null()
            ]),
            records_processed: z.union([
                z.int(),
                z.null()
            ])
        }))
    }),
    z.object({
        import_id: z.string(),
        file_name: z.string()
    }),
    z.object({
        import_id: z.string(),
        source_rows: z.optional(z.int()),
        import_type: z.optional(z.string())
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string(),
        source_rows: z.union([
            z.int(),
            z.null()
        ]),
        records_total: z.int(),
        records_created: z.int(),
        records_updated: z.int(),
        records_skipped: z.int(),
        records_errored: z.int(),
        records_processed: z.int()
    }),
    z.object({
        import_id: z.string(),
        source_rows: z.union([
            z.int(),
            z.null()
        ]),
        records_total: z.int(),
        records_created: z.int(),
        records_updated: z.int(),
        records_skipped: z.int(),
        records_errored: z.int(),
        records_processed: z.int()
    }),
    z.object({
        import_id: z.string(),
        error: z.string()
    }),
    z.object({
        import_id: z.string(),
        error: z.string()
    }),
    z.object({
        import_id: z.string(),
        error: z.string()
    })
]);

export const zIngestionApiImportsGetImportData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        import_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zIngestionApiImportsGetImportResponse = zImportRunDetailOut;

export const zIngestionApiImportsListImportErrorsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        import_id: z.uuid()
    }),
    query: z.optional(z.object({
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zIngestionApiImportsListImportErrorsResponse = zPaginatedImportRowErrorResponse;

export const zIngestionApiImportsDownloadImportErrorsCsvData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        import_id: z.uuid()
    }),
    query: z.optional(z.never())
});

export const zIngestionApiImportsImportEventsStreamData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        import_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * Server-Sent Events stream.
 *
 * Wire format per message:
 * ```
 * event: <type>
 * data: <json>
 *
 * ```
 *
 * A `:keepalive` comment is sent every 30 s.
 */
export const zIngestionApiImportsImportEventsStreamResponse = z.union([
    z.object({
        import_id: z.string(),
        status: z.string(),
        source_rows: z.union([
            z.int(),
            z.null()
        ]),
        records_total: z.union([
            z.int(),
            z.null()
        ]),
        records_created: z.union([
            z.int(),
            z.null()
        ]),
        records_updated: z.union([
            z.int(),
            z.null()
        ]),
        records_skipped: z.union([
            z.int(),
            z.null()
        ]),
        records_errored: z.optional(z.union([
            z.int(),
            z.null()
        ])),
        records_processed: z.optional(z.union([
            z.int(),
            z.null()
        ]))
    }),
    z.object({
        import_id: z.string(),
        file_name: z.string()
    }),
    z.object({
        import_id: z.string(),
        source_rows: z.optional(z.int()),
        import_type: z.optional(z.string())
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string()
    }),
    z.object({
        import_id: z.string(),
        source_rows: z.union([
            z.int(),
            z.null()
        ]),
        records_total: z.int(),
        records_created: z.int(),
        records_updated: z.int(),
        records_skipped: z.int(),
        records_errored: z.int(),
        records_processed: z.int()
    }),
    z.object({
        import_id: z.string(),
        source_rows: z.union([
            z.int(),
            z.null()
        ]),
        records_total: z.int(),
        records_created: z.int(),
        records_updated: z.int(),
        records_skipped: z.int(),
        records_errored: z.int(),
        records_processed: z.int()
    }),
    z.object({
        import_id: z.string(),
        error: z.string()
    }),
    z.object({
        import_id: z.string(),
        error: z.string()
    }),
    z.object({
        import_id: z.string(),
        error: z.string()
    })
]);

export const zIngestionApiConnectionsConnectionStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zIngestionApiConnectionsConnectionStatsResponse = zConnectionStatsOut;

export const zIngestionApiConnectionsListConnectionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        is_active: z.optional(z.union([
            z.boolean(),
            z.null()
        ])),
        delivery_mechanism: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zIngestionApiConnectionsListConnectionsResponse = zPaginatedConnectionResponse;

export const zIngestionApiConnectionsCreateConnectionData = z.object({
    body: zConnectionIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Created
 */
export const zIngestionApiConnectionsCreateConnectionResponse = zConnectionOut;

export const zIngestionApiConnectionsDeleteConnectionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        connection_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * No Content
 */
export const zIngestionApiConnectionsDeleteConnectionResponse = z.void();

export const zIngestionApiConnectionsGetConnectionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        connection_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zIngestionApiConnectionsGetConnectionResponse = zConnectionOut;

export const zIngestionApiConnectionsUpdateConnectionData = z.object({
    body: zConnectionPatch,
    path: z.object({
        connection_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zIngestionApiConnectionsUpdateConnectionResponse = zConnectionOut;

export const zIngestionApiConnectionsTestConnectionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        connection_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zIngestionApiConnectionsTestConnectionResponse = zConnectionTestOut;

export const zIngestionApiConnectionsSyncConnectionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        connection_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zIngestionApiConnectionsSyncConnectionResponse = zConnectionTestOut;

export const zProjectsApiMissionControlDashboardSummaryData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        plan_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        cycle_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        region_id: z.optional(z.union([
            z.array(z.uuid()),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zProjectsApiMissionControlDashboardSummaryResponse = zMissionControlSummaryOut;

export const zProjectsApiMissionControlListWorkOrdersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        project_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        plan_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        cycle_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        assigned_employee: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        visit: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        date: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        project_active_only: z.optional(z.boolean()).default(false),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiMissionControlListWorkOrdersResponse = zPaginatedWorkOrderResponse;

export const zProjectsApiMissionControlListAlertsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Response
 *
 * OK
 */
export const zProjectsApiMissionControlListAlertsResponse = z.array(zAlertOut);

export const zProjectsApiMissionControlListEscalationsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        severity: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiMissionControlListEscalationsResponse = zPaginatedEscalationResponse;

export const zProjectsApiMissionControlResolveEscalationData = z.object({
    body: zEscalationActionIn,
    path: z.object({
        escalation_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiMissionControlResolveEscalationResponse = zEscalationOut;

export const zProjectsApiNiciTrackingNiciProjectSummaryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.object({
        cycle_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ]))
    }))
});

/**
 * OK
 */
export const zProjectsApiNiciTrackingNiciProjectSummaryResponse = zNiciTrackingSummaryOut;

export const zProjectsApiNiciTrackingListNiciStoresData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.object({
        cycle_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        task_status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        ordering: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiNiciTrackingListNiciStoresResponse = zPaginatedNiciTrackingStoreResponse;

export const zProjectsApiNiciTrackingListNiciItemsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid()
    }),
    query: z.optional(z.object({
        cycle_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        search: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        category_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        ordering: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiNiciTrackingListNiciItemsResponse = zPaginatedNiciTrackingItemResponse;

export const zProjectsApiNiciTrackingNiciItemRolloutData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        project_id: z.uuid(),
        product_id: z.uuid()
    }),
    query: z.optional(z.object({
        cycle_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        ordering: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiNiciTrackingNiciItemRolloutResponse = zPaginatedNiciTrackingRolloutResponse;

export const zProjectsApiFieldworkListAssignedStoresData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        employee: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        date: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        work_order_active_only: z.optional(z.boolean()).default(false),
        project_active_only: z.optional(z.boolean()).default(false),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiFieldworkListAssignedStoresResponse = zPaginatedFieldworkAssignedStoreResponse;

export const zProjectsApiFieldworkUpdateVisitData = z.object({
    body: z.object({
        status: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        planned_date: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        notes: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        manager_name: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        manager_rating: z.optional(z.union([
            z.int(),
            z.null()
        ])),
        manager_comment: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        signature: z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }),
    path: z.object({
        visit_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiFieldworkUpdateVisitResponse = zFieldworkVisitOut;

export const zProjectsApiFieldworkListVisitAssignmentsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        date: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        employee: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        visit: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiFieldworkListVisitAssignmentsResponse = zPaginatedFieldworkAssignmentResponse;

export const zProjectsApiFieldworkGetVisitAssignmentData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        visit_assignment_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiFieldworkGetVisitAssignmentResponse = zFieldworkAssignmentOut;

export const zProjectsApiFieldworkUpdateVisitAssignmentData = z.object({
    body: zFieldworkAssignmentUpdateIn,
    path: z.object({
        visit_assignment_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiFieldworkUpdateVisitAssignmentResponse = zFieldworkAssignmentOut;

export const zProjectsApiFieldworkListWorkItemsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        visit: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        store: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        user: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        task_id: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        project_active_only: z.optional(z.boolean()).default(false),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiFieldworkListWorkItemsResponse = zPaginatedFieldworkWorkItemResponse;

export const zProjectsApiTimesheetsListTimesheetsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        date: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        employee: z.optional(z.union([
            z.uuid(),
            z.null()
        ])),
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * OK
 */
export const zProjectsApiTimesheetsListTimesheetsResponse = zPaginatedWorkdayTimesheetResponse;

export const zProjectsApiTimesheetsGetTimesheetData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        timesheet_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiTimesheetsGetTimesheetResponse = zWorkdayTimesheetOut;

export const zProjectsApiTimesheetsUpdateTimesheetData = z.object({
    body: zWorkdayTimesheetUpdateIn,
    path: z.object({
        timesheet_id: z.uuid()
    }),
    query: z.optional(z.object({
        dry_run: z.optional(z.boolean()).default(false)
    }))
});

/**
 * Response
 *
 * OK
 */
export const zProjectsApiTimesheetsUpdateTimesheetResponse = z.union([
    zWorkdayTimesheetOut,
    zDaySubmitPreviewOut
]);

export const zProjectsApiTimesheetsGetBreakFormData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        timesheet_id: z.uuid()
    }),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zProjectsApiTimesheetsGetBreakFormResponse = zBreakFormOut;

export const zSupervisorApiListChatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * Response
 *
 * OK
 */
export const zSupervisorApiListChatsResponse = z.record(z.string(), z.unknown());

export const zSupervisorApiCreateChatData = z.object({
    body: zCreateChatIn,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * OK
 */
export const zSupervisorApiCreateChatResponse = zCreateChatOut;

export const zSupervisorApiListMessagesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        chat_id: z.uuid()
    }),
    query: z.optional(z.object({
        page: z.optional(z.int()).default(1),
        page_size: z.optional(z.int()).default(25)
    }))
});

/**
 * Response
 *
 * OK
 */
export const zSupervisorApiListMessagesResponse = z.record(z.string(), z.unknown());

export const zSupervisorApiSendMessageData = z.object({
    body: zSendMessageIn,
    path: z.object({
        chat_id: z.uuid()
    }),
    query: z.optional(z.never())
});
